// import React, { useEffect, useMemo, useState, useCallback } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { jwtDecode } from "jwt-decode";
// import jsPDF from 'jspdf';
// import autoTable from 'jspdf-autotable';
// import AlertBox from '../../Components/AlertBox';
// import {
//   ArrowLeft,
//   Calendar,
//   IndianRupee,
//   Target,
//   Clock,
//   Users,
//   Mail,
//   Phone,
//   BarChart3,
//   Building2,
//   Plus,
//   X,
//   Sparkles,
//   Download
// } from 'lucide-react';

// const ProjectView = ({ projects = [], employees: employeesProp = [], milestones = [], setMilestones, onNavigate, projectId }) => {
//   const [isLoaded, setIsLoaded] = useState(false);

//   console.log("projectId prop received:",projectId);
//   console.log("projects array length:", projects?.length);

//   useEffect(() => {
//     setTimeout(() => setIsLoaded(true), 100);
//   }, []);

//   // ---------- Enhanced styles ----------
//   const projectViewStyle = {
//     minHeight: '100vh',
//     padding: '6rem',
//     fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif',
//     position: 'relative',
//     overflow: 'hidden',
//   };

//   const pageHeaderStyle = {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     marginBottom: '3rem',
//     padding: '2rem',
//     background: 'rgba(255, 255, 255, 0.95)',
//     borderRadius: '1.5rem',
//     border: '1px solid rgba(0, 0, 0, 0.1)',
//     boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
//     animation: isLoaded ? 'fadeInUp 0.6s ease-out' : 'none',
//     transition: 'all 0.3s ease'
//   };

//   const headerTitleStyle = {
//     fontSize: '2.5rem',
//     fontWeight: 900,
//     color: '#333',
//     margin: 0,
//     display: 'flex',
//     alignItems: 'center',
//     gap: '1rem'
//   };

//   const btnStyle = {
//     display: 'inline-flex',
//     alignItems: 'center',
//     padding: '0.75rem 1.5rem',
//     border: 'none',
//     borderRadius: '50px',
//     fontWeight: 600,
//     textDecoration: 'none',
//     cursor: 'pointer',
//     transition: 'all 0.3s ease',
//     gap: '0.75rem',
//     fontSize: '1rem',
//     boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
//   };

//   const btnSecondaryStyle = {
//     ...btnStyle,
//     background: '#f8f9fa',
//     color: '#333',
//     border: '1px solid #dee2e6'
//   };

//   const cardStyle = {
//     background: 'rgba(255, 255, 255, 0.95)',
//     borderRadius: '1.5rem',
//     padding: '2.5rem',
//     border: '1px solid rgba(0, 0, 0, 0.1)',
//     boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
//     marginBottom: '2rem',
//     animation: isLoaded ? 'fadeInUp 0.8s ease-out' : 'none',
//     transition: 'all 0.3s ease'
//   };

//   const projectMetaGrid = {
//     display: 'grid',
//     gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
//     gap: '1rem',
//     marginTop: '1rem'
//   };

//   const metaItemStyle = {
//     display: 'flex',
//     alignItems: 'center',
//     gap: '1rem',
//     padding: '1.5rem',
//     background: '#f8f9fa',
//     borderRadius: '1rem',
//     border: '1px solid #dee2e6',
//     boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
//     transition: 'all 0.3s ease',
//   };

//   const metaIconStyle = { width: 24, height: 24, color: '#667eea', transition: 'all 0.3s ease' };
//   const metaLabelStyle = { fontSize: '0.9rem', color: '#6c757d', marginBottom: '1rem' };
//   const metaValueStyle = { fontSize: '1.1rem', fontWeight: 700, color: '#333', margin: 0 };

//   const sectionTitleStyle = { 
//     fontSize: '1.5rem', 
//     fontWeight: 700, 
//     color: '#333', 
//     margin: 0, 
//     marginBottom: '1.5rem',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.75rem'
//   };

//   const statusBadgeBase = {
//     padding: '0.5rem 1rem',
//     borderRadius: '50px',
//     fontSize: '0.8rem',
//     fontWeight: 700,
//     textTransform: 'uppercase',
//     boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
//     transition: 'all 0.3s ease'
//   };
//   const getStatusBadgeStyle = (status) => {
//     switch (status) {
//       case 'Completed': return { ...statusBadgeBase, background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', color: 'white' };
//       case 'Late Completed': return { ...statusBadgeBase, background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)', color: 'white' };
//       case 'Overdue': return { ...statusBadgeBase, background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)', color: 'white' };
//       case 'In Progress': return { ...statusBadgeBase, background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)', color: 'white' };
//       case 'Pending': return { ...statusBadgeBase, background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)', color: 'white' };
//       default: return { ...statusBadgeBase, background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)', color: 'white' };
//     }
//   };

//   const progressTrack = { 
//     width: '100%', 
//     height: 12, 
//     background: '#e9ecef', 
//     borderRadius: '50px', 
//     overflow: 'hidden',
//     boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.1)'
//   };
//   const progressFill = (pct) => ({ 
//     width: `${pct}%`, 
//     height: '100%', 
//     background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
//     borderRadius: '50px',
//     transition: 'all 0.5s ease'
//   });

//   const teamCardStyle = {
//     padding: '1.5rem',
//     background: '#f8f9fa',
//     borderRadius: '1rem',
//     border: '1px solid #dee2e6',
//     boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
//     transition: 'all 0.3s ease',
//   };

//   const emptyStateStyle = { 
//     textAlign: 'center', 
//     padding: '3rem', 
//     color: '#6c757d',
//     fontSize: '1.1rem',
//   };

//   const exportButtonStyle = {
//     position: 'absolute',
//     top: '2rem',
//     right: '2rem',
//     padding: '0.75rem 1.5rem',
//     backgroundColor: '#3b82f6',
//     color: 'white',
//     border: 'none',
//     borderRadius: '0.5rem',
//     fontSize: '0.9rem',
//     fontWeight: 600,
//     cursor: 'pointer',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '0.5rem',
//     boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
//     transition: 'all 0.2s ease',
//     zIndex: 10
//   };

//   const exportButtonHoverStyle = {
//     backgroundColor: '#2563eb',
//     transform: 'translateY(-2px)',
//     boxShadow: '0 6px 16px rgba(59, 130, 246, 0.4)'
//   };

//   // ---------- PDF Export Function ----------
//   const exportToPDF = async () => {
//     const doc = new jsPDF();
//     const currentDate = fmtDate(new Date());

//     // Function to add border to current page with reduced margins
//     const addPageBorder = () => {
//       doc.setDrawColor(0, 0, 0); // Black color
//       doc.setLineWidth(0.3); // Thinner border line
//       doc.rect(3, 3, 204, 291); // Further reduced page margins for maximum content space
//     };

//     // Add border to first page
//     addPageBorder();

//     // Add title with proper padding from border
//     doc.setFontSize(16); // Reduced font size
//     doc.setTextColor(31, 41, 55);
//     doc.text(`Project: ${project.title || project.name}`, 8, 18); // Added padding from border

//     // Add date in top right corner with padding
//     doc.setFontSize(9);
//     doc.setTextColor(107, 114, 128);
//     const dateText = `Generated: ${currentDate}`;
//     const dateWidth = doc.getTextWidth(dateText);
//     doc.text(dateText, 202 - dateWidth, 12); // Added padding from right border

//     // Project Overview Table - With proper padding
//     doc.setFontSize(14); // Reduced font size
//     doc.setTextColor(31, 41, 55);
//     doc.text('Project Details', 8, 32); // Added padding from border

//     const projectOverviewData = [
//       ['Project Name', project.title || project.name || 'N/A'],
//       ['Description', project.description || 'N/A'],
//       ['Status', project.status || 'N/A'],
//       ['Start Date', fmtDate(start)],
//       ['Due Date', fmtDate(due)],
//       ['Budget', `Rs. ${budget.toLocaleString('en-IN')}`],
//       ['Progress', `${progressData.percentage}/100`]
//     ];

//     autoTable(doc, {
//       startY: 38, // Proper padding from title
//       head: [['Field', 'Value']],
//       body: projectOverviewData,
//       theme: 'striped',
//       headStyles: {
//         fillColor: [59, 130, 246],
//         textColor: [255, 255, 255],
//         fontStyle: 'bold',
//         fontSize: 9, // Reduced font size
//         cellPadding: 2 // Reduced padding
//       },
//       styles: {
//         fontSize: 8, // Reduced font size
//         cellPadding: 3 // Reduced padding
//       },
//       columnStyles: {
//         0: { cellWidth: 65, fontStyle: 'bold' }, // Slightly increased for better fit
//         1: { cellWidth: 125 } // Increased to use more space
//       },
//       margin: { left: 8, right: 8, top: 5, bottom: 8 }, // Proper padding from border
//       didDrawPage: function (data) {
//         // Add border to each new page
//         addPageBorder();
//       }
//     });

//     let currentY = doc.lastAutoTable.finalY + 10; // Proper section spacing

//     // Department Information Table (if available)
//     if (project.department) {
//       doc.setFontSize(14); // Reduced font size
//       doc.setTextColor(31, 41, 55);
//       doc.text('Department Information', 8, currentY); // Proper padding from border

//       const departmentData = [];
//       console.log('Project department:', project.department);
//       console.log('Available departments:', department);

//       if (Array.isArray(project.department)) {
//         project.department.forEach((dept, index) => {
//           let deptName = 'Unknown Department';

//           if (typeof dept === 'object' && dept.name) {
//             deptName = dept.name;
//           } else if (typeof dept === 'string') {
//             const foundDept = department.find(d => d._id === dept || d.id === dept);
//             console.log(`Looking for department ${dept}:`, foundDept);
//             deptName = foundDept ? (foundDept.name || foundDept.departmentName || 'Unknown Department') : dept;
//           }

//           departmentData.push([`Department ${index + 1}`, deptName]);
//         });
//       } else {
//         let deptName = 'Unknown Department';

//         if (typeof project.department === 'object' && project.department.name) {
//           deptName = project.department.name;
//         } else if (typeof project.department === 'string') {
//           const foundDept = department.find(d => d._id === project.department || d.id === project.department);
//           console.log(`Looking for single department ${project.department}:`, foundDept);
//           deptName = foundDept ? (foundDept.name || foundDept.departmentName || 'Unknown Department') : project.department;
//         }

//         departmentData.push(['Department', deptName]);
//       }

//       autoTable(doc, {
//         startY: currentY + 8, // Proper spacing from section title
//         head: [['Field', 'Value']],
//         body: departmentData,
//         theme: 'striped',
//         headStyles: {
//           fillColor: [99, 102, 241],
//           textColor: [255, 255, 255],
//           fontStyle: 'bold'
//         },
//         styles: {
//           fontSize: 9, // Reduced font size
//           cellPadding: 3 // Reduced cell padding
//         },
//         columnStyles: {
//           0: { cellWidth: 60, fontStyle: 'bold' },
//           1: { cellWidth: 100 }
//         },
//         margin: { left: 8, right: 8, top: 5, bottom: 8 }, // Proper padding from border
//         didDrawPage: function (data) {
//           addPageBorder();
//         }
//       });

//       currentY = doc.lastAutoTable.finalY + 8; // Proper section spacing
//     }

//     // Client Information Table (if available)
//     if (project.clientName || project.clientCompany || project.clientEmail || project.clientMobileNo || project.clientAddress || project.clientCity || project.clientState) {
//       doc.setFontSize(14); // Reduced font size
//       doc.setTextColor(31, 41, 55);
//       doc.text('Client Information', 8, currentY); // Proper padding from border

//       const clientData = [];
//       if (project.clientName) clientData.push(['Client Name', project.clientName]);
//       if (project.clientCompany) clientData.push(['Company', project.clientCompany]);
//       if (project.clientEmail) clientData.push(['Email', project.clientEmail]);
//       if (project.clientMobileNo) clientData.push(['Mobile', project.clientMobileNo]);
//       if (project.clientAddress) clientData.push(['Address', project.clientAddress]);
//       if (project.clientCity) clientData.push(['City', project.clientCity]);
//       if (project.clientState) clientData.push(['State', project.clientState]);

//       autoTable(doc, {
//         startY: currentY + 8, // Proper spacing from section title
//         head: [['Field', 'Value']],
//         body: clientData,
//         theme: 'striped',
//         headStyles: {
//           fillColor: [16, 185, 129],
//           textColor: [255, 255, 255],
//           fontStyle: 'bold'
//         },
//         styles: {
//           fontSize: 9, // Reduced font size
//           cellPadding: 3 // Reduced cell padding
//         },
//         columnStyles: {
//           0: { cellWidth: 60, fontStyle: 'bold' },
//           1: { cellWidth: 100 }
//         },
//         margin: { left: 8, right: 8, top: 5, bottom: 8 }, // Proper padding from border
//         didDrawPage: function (data) {
//           addPageBorder();
//         }
//       });

//       currentY = doc.lastAutoTable.finalY + 8; // Proper section spacing
//     }

//     // Project Head Information (if available)
//     if (project.projectHead) {
//       doc.setFontSize(14); // Reduced font size
//       doc.setTextColor(31, 41, 55);
//       doc.text('Project Head', 8, currentY); // Proper padding from border

//       let projectHeadName = 'Unknown';
//       let projectHeadPosition = 'Position not available';
//       let projectHeadEmail = 'N/A';

//       const projectHeadId = typeof project.projectHead === 'string' ? project.projectHead : project.projectHead?._id;

//       // First check cached detailed employee data
//       const detailedProjectHead = employeeDetails[projectHeadId];
//       if (detailedProjectHead) {
//         console.log('✅ Using cached detailed project head data for PDF:', detailedProjectHead);
//         projectHeadName = detailedProjectHead.teamMemberName || detailedProjectHead.name || 'Unknown';
//         projectHeadEmail = detailedProjectHead.email || detailedProjectHead.emailAddress || 'N/A';
//         projectHeadPosition = detailedProjectHead.role || 
//                              detailedProjectHead.position || 
//                              detailedProjectHead.designation || 
//                              detailedProjectHead.jobTitle || 
//                              detailedProjectHead.title || 
//                              detailedProjectHead.employeePosition ||
//                              detailedProjectHead.department ||
//                              'Position not available';
//       } else if (typeof project.projectHead === 'object' && (project.projectHead.name || project.projectHead.teamMemberName)) {
//         projectHeadName = project.projectHead.teamMemberName || project.projectHead.name;
//         projectHeadEmail = project.projectHead.email || project.projectHead.emailAddress || 'N/A';
//         projectHeadPosition = project.projectHead.role || 
//                              project.projectHead.position || 
//                              project.projectHead.designation || 
//                              'Position not available';
//       } else if (typeof project.projectHead === 'string' && employees.length > 0) {
//         const headDetails = employees.find(emp => String(emp._id) === String(project.projectHead));
//         if (headDetails) {
//           projectHeadName = headDetails.teamMemberName || headDetails.name || 'Unknown';
//           projectHeadEmail = headDetails.email || headDetails.emailAddress || 'N/A';
//           projectHeadPosition = headDetails.role || 
//                                headDetails.position || 
//                                headDetails.designation || 
//                                'Position not available';
//         } else {
//           projectHeadName = `ID: ${project.projectHead}`;
//         }
//       } else {
//         projectHeadName = `ID: ${project.projectHead}`;
//       }

//       const projectHeadData = [
//         ['Name', projectHeadName],
//         ['Email', projectHeadEmail],
//         ['Position', projectHeadPosition]
//       ];

//       autoTable(doc, {
//         startY: currentY + 8, // Proper spacing from section title
//         head: [['Field', 'Value']],
//         body: projectHeadData,
//         theme: 'striped',
//         headStyles: {
//           fillColor: [147, 51, 234],
//           textColor: [255, 255, 255],
//           fontStyle: 'bold'
//         },
//         styles: {
//           fontSize: 9, // Reduced font size
//           cellPadding: 3 // Reduced cell padding
//         },
//         columnStyles: {
//           0: { cellWidth: 60, fontStyle: 'bold' },
//           1: { cellWidth: 100 }
//         },
//         margin: { left: 8, right: 8, top: 5, bottom: 8 }, // Proper padding from border
//         didDrawPage: function (data) {
//           addPageBorder();
//         }
//       });

//       currentY = doc.lastAutoTable.finalY + 8; // Proper section spacing
//     }

//     // Other Information (if available)
//     if (project.customFields && project.customFields.length > 0) {
//       doc.setFontSize(14); // Reduced font size
//       doc.setTextColor(31, 41, 55);
//       doc.text('Other Information', 8, currentY); // Proper padding from border

//       const customFieldsData = project.customFields.map(field => [field.key, field.value]);

//       autoTable(doc, {
//         startY: currentY + 8, // Proper spacing from section title
//         head: [['Name', 'Particular']],
//         body: customFieldsData,
//         theme: 'striped',
//         headStyles: {
//           fillColor: [251, 146, 60],
//           textColor: [255, 255, 255],
//           fontStyle: 'bold'
//         },
//         styles: {
//           fontSize: 9, // Reduced font size
//           cellPadding: 3 // Reduced cell padding
//         },
//         columnStyles: {
//           0: { cellWidth: 60, fontStyle: 'bold' },
//           1: { cellWidth: 100 }
//         },
//         margin: { left: 8, right: 8, top: 5, bottom: 8 }, // Proper padding from border
//         didDrawPage: function (data) {
//           addPageBorder();
//         }
//       });

//       currentY = doc.lastAutoTable.finalY + 8; // Proper section spacing
//     }

//     // Team Members Table
//     if (teamMembers.length > 0) {
//       // Check if we need a new page for the team members section
//       if (currentY > 220) {
//         doc.addPage();
//         addPageBorder();
//         currentY = 18; // Proper padding from top border
//       }

//       doc.setFontSize(14); // Reduced font size
//       doc.setTextColor(31, 41, 55);
//       doc.text('Team Members', 8, currentY); // Proper padding from border

//       // Debug team members data for PDF
//       console.log('PDF Team Members Debug:', teamMembers);
//       console.log('Team Members Length:', teamMembers.length);
//       if (teamMembers.length > 0) {
//         console.log('First Team Member Sample:', teamMembers[0]);
//         console.log('First Team Member Keys:', Object.keys(teamMembers[0]));
//       }

//       const teamData = teamMembers.map((member, index) => {
//         console.log(`PDF Team Member ${index}:`, {
//           name: member.teamMemberName || member.name,
//           email: member.email,
//           role: member.role
//         });

//         return [
//           member.teamMemberName || member.name || 'N/A',
//           member.email || 'N/A',
//           member.role || 'Position not available'
//         ];
//       });

//       console.log('Final PDF Team Data:', teamData);

//       autoTable(doc, {
//         startY: currentY + 8, // Proper spacing from section title
//         head: [['Name', 'Email', 'Position']],
//         body: teamData,
//         theme: 'striped',
//         headStyles: {
//           fillColor: [139, 92, 246],
//           textColor: [255, 255, 255],
//           fontStyle: 'bold'
//         },
//         styles: {
//           fontSize: 8, // Reduced font size
//           cellPadding: 2, // Reduced padding
//           overflow: 'linebreak',
//           halign: 'left'
//         },
//         columnStyles: {
//           0: { cellWidth: 65, fontStyle: 'bold' }, // Optimized widths
//           1: { cellWidth: 70 },
//           2: { cellWidth: 65 }
//         },
//         margin: { left: 8, right: 8, top: 5, bottom: 8 }, // Proper padding from border to match other sections
//         tableWidth: 150,
//         showHead: 'everyPage',
//         didDrawPage: function (data) {
//           addPageBorder();
//         }
//       });

//       currentY = doc.lastAutoTable.finalY + 8; // Proper section spacing
//     }

//     // Project-Tasks section with proper page break handling
//     if (localMilestones.length > 0) {
//       // Check if we need a new page for the project-tasks section
//       if (currentY > 220) {
//         doc.addPage();
//         addPageBorder();
//         currentY = 18; // Proper padding from top border
//       }

//       doc.setFontSize(14); // Reduced font size
//       doc.setTextColor(31, 41, 55);
//       doc.text('Project-Tasks', 8, currentY); // Proper padding from border

//       // Helper function to fetch employee name from API
//       const fetchEmployeeNameFromAPI = async (employeeIdOrObject) => {
//         try {
//           const authToken = localStorage.getItem('authToken');
//           if (!authToken || !employeeIdOrObject) {
//             return 'Unknown';
//           }

//           // Extract actual ID from object or use string directly
//           let employeeId;
//           if (typeof employeeIdOrObject === 'object' && employeeIdOrObject !== null) {
//             employeeId = employeeIdOrObject._id || employeeIdOrObject.id || employeeIdOrObject.employeeId;
//             console.log(`Extracted ID from object: ${employeeId}`, employeeIdOrObject);
//           } else {
//             employeeId = employeeIdOrObject;
//           }

//           if (!employeeId) {
//             console.log(`❌ No valid employee ID found in:`, employeeIdOrObject);
//             return 'Unknown Employee';
//           }

//           console.log(`API Call - Fetching employee details for ID: ${employeeId}`);

//           const response = await fetch(`https://crm-tkxn.onrender.com/api/employees/${employeeId}`, {
//             headers: {
//               'Authorization': `Bearer ${authToken}`,
//               'Content-Type': 'application/json'
//             }
//           });

//           if (response.ok) {
//             const employeeData = await response.json();
//             console.log(`✅ API Response - Employee data:`, employeeData);

//             const name = employeeData.teamMemberName || 
//                         employeeData.name || 
//                         employeeData.firstName || 
//                         employeeData.displayName ||
//                         employeeData.fullName;

//             if (name && typeof name === 'string' && name.trim()) {
//               console.log(`✅ Extracted employee name: ${name}`);
//               return name.trim();
//             }

//             console.log(`⚠️ No name found in employee data for ID: ${employeeId}`);
//             return `Employee ID: ${employeeId}`;
//           } else {
//             console.error(`❌ API Error - Failed to fetch employee ${employeeId}:`, response.status);
//             return `Employee ID: ${employeeId}`;
//           }
//         } catch (error) {
//           console.error(`❌ API Error - Exception fetching employee:`, error);
//           return `Employee ID: ${employeeIdOrObject}`;
//         }
//       };

//       const followUpData = await Promise.all(localMilestones.map(async (milestone) => {
//         const dueDate = milestone.dueDate ? fmtDate(milestone.dueDate) : 'Not set';
//         const projectName = milestone.projectName || project.title || 'N/A';
//         const status = milestone.status || 'Pending';

//         // Debug logging for assigned team member
//         console.log(`PDF Debug - Milestone "${milestone.title}":`, {
//           assignedTeamMember: milestone.assignedTeamMember,
//           assignedTeamMemberType: typeof milestone.assignedTeamMember,
//           isArray: Array.isArray(milestone.assignedTeamMember),
//           availableEmployeeDetails: Object.keys(employeeDetails),
//           availableEmployees: employees?.length || 0,
//           fullMilestone: milestone
//         });
//         // Fetch employee name using API - simplified approach
//         const assignedTo = await (async () => {
//           if (!milestone.assignedTeamMember) {
//             return 'Unassigned';
//           }

//           console.log(`Processing assignedTeamMember:`, milestone.assignedTeamMember);

//           // Handle array of team members
//           if (Array.isArray(milestone.assignedTeamMember)) {
//             if (milestone.assignedTeamMember.length === 0) {
//               return 'Unassigned';
//             }

//             const names = await Promise.all(milestone.assignedTeamMember.map(async (member) => {
//               return await fetchEmployeeNameFromAPI(member);
//             }));

//             return names.filter(name => name !== 'Unknown' && !name.includes('Employee ID:')).join(', ') || 'Unknown';
//           }

//           // Handle single assignment (object or string)
//           return await fetchEmployeeNameFromAPI(milestone.assignedTeamMember);
//         })();
//         const nextFollowUp = milestone.nextFollowUp ? fmtDate(milestone.nextFollowUp) : 'Not set';

//         return [
//           milestone.title, 
//           milestone.description || 'No description',
//           status, 
//           dueDate, 
//           assignedTo,
//           nextFollowUp
//         ];
//       }));

//       autoTable(doc, {
//         startY: currentY + 8, // Proper spacing from section title
//         head: [['Project-Task Title', 'Description', 'Status', 'Due Date', 'Assigned To', 'Next Follow-up']],
//         body: followUpData,
//         theme: 'striped',
//         headStyles: {
//           fillColor: [245, 158, 11],
//           textColor: [255, 255, 255],
//           fontStyle: 'bold'
//         },
//         styles: {
//           fontSize: 7, // Further reduced font size
//           cellPadding: 1.5, // Reduced padding
//           overflow: 'linebreak',
//           halign: 'left'
//         },
//         columnStyles: {
//           0: { cellWidth: 32, fontStyle: 'bold' }, // Optimized widths
//           1: { cellWidth: 30 },
//           2: { cellWidth: 22 },
//           3: { cellWidth: 28 },
//           4: { cellWidth: 30 },
//           5: { cellWidth: 28 }
//         },
//         margin: { left: 8, right: 8 }, // Reduced margins
//         tableWidth: 150,
//         showHead: 'everyPage',
//         didDrawPage: function (data) {
//           addPageBorder();
//         }
//       });
//     }

//     // Save the PDF
//     const projectName = (project.title || project.name || 'Project').replace(/[^a-zA-Z0-9]/g, '-');
//     doc.save(`${projectName}-Details-${currentDate.replace(/\//g, '-')}.pdf`);
//   };

//   // ---------- hooks ----------
//   const { id } = useParams();
//   const navigate = useNavigate();

//   // Get project ID from props first, then useParams, then URL
//   const getCurrentProjectId = () => {
//     if (projectId) {
//       console.log('✅ Using projectId from props:', projectId);
//       return projectId; // Use prop if provided (from FranchiseDashboard)
//     }
//     if (id) {
//       console.log('✅ Using id from useParams:', id);
//       return id; // If useParams works (React Router), use it
//     }

//     // Otherwise, extract from window location
//     const currentPath = window.location.pathname;
//     if (currentPath.startsWith('/projects/')) {
//       const extractedId = currentPath.split('/projects/')[1];
//       console.log('✅ Using id from URL path:', extractedId);
//       return extractedId;
//     }
//     return null;
//   };

//   const currentProjectId = getCurrentProjectId();


//   // Debug logging
//   console.log('ProjectView Debug:', {
//     projectIdProp: projectId,
//     useParamsId: currentProjectId,
//     currentProjectId: currentProjectId,
//     projectsCount: projects.length,
//     foundProject: projects.find(p => String(p._id || p.id) === String(currentProjectId))
//   });

//   // Try to fetch employees if not provided (fallback)
//   const [employees, setEmployees] = useState(employeesProp);
//   const [department, setDepartment] = useState([]);
//   const [showFollowUpForm, setShowFollowUpForm] = useState(false);
//   const [localMilestones, setLocalMilestones] = useState(Array.isArray(milestones) ? milestones : []);
//   const [showAlert, setShowAlert] = useState(null);
//   const [followUpFormData, setFollowUpFormData] = useState({
//     title: '',
//     projectName: '',
//     description: '',
//     dueDate: '',
//     status: '',
//     assignedTeamMember: [], // Changed to array for multiple employees
//     nextFollowUp: ''
//   });
//   const [hoveredExport, setHoveredExport] = useState(false);
//   const [employeeDetails, setEmployeeDetails] = useState({});
//   // Status management for milestones - fixed 5 statuses with late completion tracking
//   const [statusOptions, setStatusOptions] = useState(['Pending', 'In Progress', 'Completed', 'Overdue',]);
//   const [openStatusDropdown, setOpenStatusDropdown] = useState(null);
//   const [openTeamMemberDropdown, setOpenTeamMemberDropdown] = useState(false);


//   // Function to fetch individual employee details
//   const fetchEmployeeDetails = useCallback(async (employeeId) => {
//     try {
//       const token = localStorage.getItem('authToken');
//       if (!token) {
//         console.error('No access token found');
//         return null;
//       }

//       console.log('Fetching employee details for ID:', employeeId);

//       const response = await fetch(`https://crm-tkxn.onrender.com/api/employees/${employeeId}`, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });

//       if (response.ok) {
//         const employeeData = await response.json();
//         console.log('✅ Employee details fetched:', employeeData);
//         console.log('Available fields in employee details:', Object.keys(employeeData));

//         // Cache the employee details
//         setEmployeeDetails(prev => ({
//           ...prev,
//           [employeeId]: employeeData
//         }));

//         return employeeData;
//       } else {
//         console.error('❌ Failed to fetch employee details:', response.status);
//         return null;
//       }
//     } catch (error) {
//       console.error('❌ Error fetching employee details:', error);
//       return null;
//     }
//   }, []);

//   useEffect(() => {
//     setEmployees(employeesProp);
//   }, [employeesProp]);

//   useEffect(() => {
//     setLocalMilestones(Array.isArray(milestones) ? milestones : []);
//   }, [milestones]);


//   // Close dropdown when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (openStatusDropdown && !event.target.closest('[data-dropdown-container]')) {
//         setOpenStatusDropdown(null);
//       }
//       if (openTeamMemberDropdown && !event.target.closest('[data-team-dropdown-container]')) {
//         setOpenTeamMemberDropdown(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [openStatusDropdown, openTeamMemberDropdown]);

//   // Update form default status when statusOptions change
//   useEffect(() => {
//     console.log('ProjectView - statusOptions updated:', statusOptions);
//     // If form is open and no status is selected, set the first available status
//     if (showFollowUpForm && !followUpFormData.status && statusOptions.length > 0) {
//       console.log('ProjectView - Auto-setting status to:', statusOptions[0]);
//       setFollowUpFormData(prev => ({
//         ...prev,
//         status: statusOptions[0]
//       }));
//     }
//   }, [statusOptions, showFollowUpForm, followUpFormData.status]);

//   useEffect(() => {
//     const fetchEmployees = async () => {
//       try {
//         // Get token from localStorage
//         const token = localStorage.getItem('authToken');

//         let COMPANY_ID = '';
//         if (token) {
//           try {
//             const decodedToken = jwtDecode(token); // Decode JWT
//             // COMPANY_ID = decodedToken.companyId; // Extract the `id` field
//             COMPANY_ID=  decodedToken.role === 'company' 
//             ? (decodedToken.companyId || decodedToken.id) 
//             : decodedToken.companyId;

//             console.log("Decoded Token:", decodedToken);
//             console.log("Extracted Company ID:", COMPANY_ID);
//           } catch (err) {
//             console.error("Error decoding token:", err);
//           }
//         }

//         console.log("authToken", token);

//         const res = await fetch(`https://crm-tkxn.onrender.com/api/employees/company/${COMPANY_ID}`, {
//           headers: {
//             'Authorization': `Bearer ${token}`,
//             'Content-Type': 'application/json',
//           },
//         });
//         console.log("res", res);

//         if (res.ok) {
//           const data = await res.json();
//           console.log("Employees data received:", data);
//           console.log("Number of employees:", data?.length);
//           if (data && data.length > 0) {
//             console.log("First employee sample:", data[0]);
//           }
//           setEmployees(data ? data.filter(emp => emp.isActive !== false) : []);
//         } else {
//           console.error('Failed to fetch employees - Status:', res.status);
//           // Try fallback without company ID
//           const fallbackRes = await fetch('https://crm-tkxn.onrender.com/api/employees', {
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json',
//             },
//           });
//           if (fallbackRes.ok) {
//             const fallbackData = await fallbackRes.json();
//             console.log("Fallback employees data:", fallbackData);
//             setEmployees(fallbackData || []);
//           } else {
//             setEmployees([]);
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching employees:', error);
//         setEmployees([]);
//       }
//     };
//     fetchEmployees();
//   }, []);

//   // Fetch departments for name resolution
//   useEffect(() => {
//     const fetchDepartments = async () => {
//       try {
//         // Get token from localStorage
//         const token = localStorage.getItem('authToken');

//         let COMPANY_ID = '';
//         if (token) {
//           try {
//             const decodedToken = jwtDecode(token); // Decode JWT
//             // COMPANY_ID = decodedToken.companyId; // Extract the `id` field
//             COMPANY_ID=  decodedToken.role === 'company' 
//             ? (decodedToken.companyId || decodedToken.id) 
//             : decodedToken.companyId;

//             console.log("Decoded Token:", decodedToken);
//             console.log("Extracted Company ID:", COMPANY_ID);
//           } catch (err) {
//             console.error("Error decoding token:", err);
//           }
//         }

//         const response = await fetch(`https://crm-tkxn.onrender.com/api/departments/company/${COMPANY_ID}`, {
//           headers: {
//             'Authorization': `Bearer ${token}`,
//             'Content-Type': 'application/json'
//           }
//         });

//         if (response.ok) {
//           const data = await response.json();
//           console.log('Fetched departments:', data);
//           setDepartment(Array.isArray(data) ? data : []);
//         } else {
//           console.error('Failed to fetch departments:', response.status);
//           setDepartment([]);
//         }
//       } catch (error) {
//         console.error('Error fetching departments:', error);
//         setDepartment([]);
//       }
//     };

//     fetchDepartments();
//   }, []);

//   // find project by id (string-safe) - moved before useEffect that depends on it
//   const [projectData, setProjectData] = useState(null);
//   const [projectLoading, setProjectLoading] = useState(false);

//   // First try to find in passed projects array
//   const projectFromArray = useMemo(
//     () => projects.find(p => String(p._id || p.id) === String(currentProjectId)),
//     [projects, currentProjectId]
//   );

//   // Fetch project from API if not found in array
//   useEffect(() => {
//     if (!projectFromArray && currentProjectId) {
//       setProjectLoading(true);
//       const fetchProject = async () => {
//         try {
//           const token = localStorage.getItem('authToken');
//           if (!token) {
//             console.error('No auth token found');
//             setProjectLoading(false);
//             return;
//           }

//           const response = await fetch(`https://crm-tkxn.onrender.com/api/projectsmgnt/${currentProjectId}`, {
//             headers: {
//               'Authorization': `Bearer ${token}`,
//               'Content-Type': 'application/json'
//             }
//           });

//           if (response.ok) {
//             const data = await response.json();
//             console.log('✅ Fetched project from API:', data);
//             setProjectData(data);
//           } else {
//             console.error('Failed to fetch project:', response.status);
//           }
//         } catch (error) {
//           console.error('Error fetching project:', error);
//         } finally {
//           setProjectLoading(false);
//         }
//       };

//       fetchProject();
//     } else if (projectFromArray) {
//       setProjectData(projectFromArray);
//       setProjectLoading(false);
//     }
//   }, [currentProjectId, projectFromArray]);

//   const project = projectData;

//   // Function to refresh milestones in real-time (moved after project definition)
//   const refreshMilestones = useCallback(async () => {
//     console.log('„ Manual milestone refresh triggered');
//     const authToken = localStorage.getItem('authToken');
//     if (!authToken || !currentProjectId) return;

//     try {
//       const res = await fetch('https://crm-tkxn.onrender.com/api/milestones', {
//         headers: { 'Authorization': `Bearer ${authToken}` }
//       });

//       if (res.ok) {
//         const response = await res.json();
//         const data = response.milestones || response;

//         const projectIdForMilestones = project?._id || currentProjectId;
//         const currentProjectName = project?.title || project?.name;

//         const projectMilestones = Array.isArray(data) ? data.filter(m => {
//           const milestoneProjectId = m.project || m.projectId;
//           const matchesId = String(milestoneProjectId) === String(projectIdForMilestones);
//           const matchesName = m.projectName === currentProjectName;
//           const matchesProjectRef = m.project && typeof m.project === 'object' && String(m.project._id) === String(projectIdForMilestones);
//           return matchesId || matchesName || matchesProjectRef;
//         }) : [];

//         console.log('✅ Refreshed milestones:', projectMilestones.length);
//         setLocalMilestones(projectMilestones);
//       }
//     } catch (error) {
//       console.error('❌ Error refreshing milestones:', error);
//     }
//   }, [currentProjectId, project]);

//   // Fetch detailed employee data for team members, project head, and milestone assignments
//   useEffect(() => {
//     const fetchEmployeeDetailsForProject = async () => {
//       if (!project) {
//         console.log('No project to fetch employee details for');
//         return;
//       }

//       const employeeIdsToFetch = [];

//       // Add project head ID if exists
//       if (project.projectHead) {
//         const projectHeadId = typeof project.projectHead === 'string' ? project.projectHead : project.projectHead._id;
//         if (projectHeadId) {
//           employeeIdsToFetch.push(projectHeadId);
//           console.log('Added project head ID to fetch:', projectHeadId);
//         }
//       }

//       // Add team member IDs
//       if (project.teamMembers && project.teamMembers.length > 0) {
//         console.log('Processing team members for detailed data:', project.teamMembers);

//         const memberIds = project.teamMembers.map(member => {
//           if (typeof member === 'string') return member;
//           if (typeof member === 'object' && member._id) return member._id;
//           return null;
//         }).filter(Boolean);

//         employeeIdsToFetch.push(...memberIds);
//         console.log('Added team member IDs to fetch:', memberIds);
//       }

//       // Add milestone assigned team member IDs
//       if (localMilestones && localMilestones.length > 0) {
//         console.log('Processing milestone assignments for detailed data:', localMilestones.length);

//         localMilestones.forEach(milestone => {
//           if (milestone.assignedTeamMember) {
//             if (Array.isArray(milestone.assignedTeamMember)) {
//               milestone.assignedTeamMember.forEach(member => {
//                 if (typeof member === 'string') {
//                   employeeIdsToFetch.push(member);
//                 } else if (typeof member === 'object' && member !== null && (member._id || member.id)) {
//                   employeeIdsToFetch.push(member._id || member.id);
//                 }
//               });
//               console.log('Added milestone team member IDs (array):', milestone.assignedTeamMember);
//             } else if (typeof milestone.assignedTeamMember === 'string') {
//               employeeIdsToFetch.push(milestone.assignedTeamMember);
//               console.log('Added milestone team member ID (string):', milestone.assignedTeamMember);
//             } else if (typeof milestone.assignedTeamMember === 'object' && milestone.assignedTeamMember !== null) {
//               const objectId = milestone.assignedTeamMember._id || milestone.assignedTeamMember.id;
//               if (objectId) {
//                 employeeIdsToFetch.push(objectId);
//                 console.log('Added milestone team member ID (object):', objectId);
//               }
//             }
//           }
//         });
//       }

//       // Remove duplicates
//       const uniqueEmployeeIds = [...new Set(employeeIdsToFetch)];
//       console.log('All unique employee IDs to fetch:', uniqueEmployeeIds);

//       // Fetch details for each employee
//       for (const employeeId of uniqueEmployeeIds) {
//         if (!employeeDetails[employeeId]) {
//           console.log('Fetching details for employee ID:', employeeId);
//           await fetchEmployeeDetails(employeeId);
//         } else {
//           console.log('✅ Already have details for employee ID:', employeeId);
//         }
//       }
//     };

//     if (project) {
//       fetchEmployeeDetailsForProject();
//     }
//   }, [project, localMilestones, employeeDetails, fetchEmployeeDetails]);

//   // Fetch milestones for this project
//   useEffect(() => {
//     const fetchMilestones = async () => {
//       // Enhanced validation with access token check
//       const authToken = localStorage.getItem('authToken');
//       if (!authToken) {
//         console.log('No access token found, skipping milestone fetch');
//         return;
//       }

//       // Always try to fetch milestones if we have an ID
//       if (currentProjectId) {
//         try {
//           console.log('Fetching milestones for project:', {
//             currentProjectId,
//             project: project,
//             projectTitle: project?.title,
//             projectName: project?.name,
//             hasAccessToken: !!authToken
//           });

//           // Use the standardized milestone API endpoint
//           const endpoint = 'https://crm-tkxn.onrender.com/api/milestones';

//           const res = await fetch(endpoint, {
//             headers: {
//               'Authorization': `Bearer ${authToken}`
//             }
//           });

//           if (res.ok) {
//             const response = await res.json();
//             console.log('All milestones fetched:', response);
//             const data = response.milestones || response;
//             console.log('Sample milestone structure:', data[0]);

//             // Filter milestones for current project - use both project ID and project name
//             const projectIdForMilestones = project?._id || currentProjectId;
//             const currentProjectName = project?.title || project?.name;

//             console.log('Filtering milestones with:', {
//               projectIdForMilestones,
//               currentProjectName,
//               totalMilestones: data?.length || 0,
//               sampleMilestone: data?.[0]
//             });

//             const projectMilestones = Array.isArray(data) ? data.filter(m => {
//               console.log('Milestone data:', {
//                 title: m.title,
//                 project: m.project,
//                 projectId: m.projectId,
//                 projectName: m.projectName,
//                 dueDate: m.dueDate,
//                 status: m.status,
//                 _id: m._id
//               });

//               // Check by project ID (most reliable)
//               const milestoneProjectId = m.project || m.projectId;
//               const matchesId = String(milestoneProjectId) === String(projectIdForMilestones);

//               // Check by project name (fallback)
//               const matchesName = m.projectName === currentProjectName;

//               // Additional check for project reference object
//               const matchesProjectRef = m.project && typeof m.project === 'object' && String(m.project._id) === String(projectIdForMilestones);

//               const matches = matchesId || matchesName || matchesProjectRef;
//               console.log(`Milestone "${m.title}":`, {
//                 projectId: milestoneProjectId,
//                 matchesId,
//                 projectName: m.projectName,
//                 matchesName,
//                 projectRef: m.project,
//                 matchesProjectRef,
//                 finalMatch: matches
//               });
//               return matches;
//             }) : [];

//             console.log('🎯 Filtered milestones for current project:', {
//               count: projectMilestones.length,
//               milestones: projectMilestones.map(m => ({
//                 title: m.title,
//                 id: m._id,
//                 projectId: m.project || m.projectId,
//                 projectName: m.projectName
//               }))
//             });
//             setLocalMilestones(projectMilestones);

//             // Also update parent component state if available
//             if (setMilestones && typeof setMilestones === 'function') {
//               setMilestones(prev => {
//                 const otherProjectMilestones = prev.filter(m => m.projectName !== currentProjectName);
//                 return [...otherProjectMilestones, ...projectMilestones];
//               });
//             }
//           } else {
//             console.error('Failed to fetch milestones:', res.status, res.statusText);
//             setLocalMilestones([]);
//           }
//         } catch (e) {
//             console.error('Error in milestone fetch:', e);
//             setLocalMilestones([]);
//         }
//       } else {
//         console.log('Skipping milestone fetch - missing requirements:', { 
//           id: !!currentProjectId,
//           currentProjectId: !!currentProjectId, 
//           project: !!project, 
//           projectName: project?.title || project?.name,
//           hasAccessToken: !!authToken 
//         });
//       }
//     };

//     // Immediate fetch without delay to ensure data loads quickly
//     fetchMilestones();
//   }, [currentProjectId, project, setMilestones]);

//   // Force milestone fetch on component mount
//   useEffect(() => {
//     const forceFetchMilestones = async () => {
//       const authToken = localStorage.getItem('authToken');
//       if (!authToken || !currentProjectId) return;

//       console.log('Force fetching milestones on component mount for project ID:', currentProjectId);

//       try {
//         const res = await fetch('https://crm-tkxn.onrender.com/api/milestones', {
//           headers: { 'Authorization': `Bearer ${authToken}` }
//         });

//         if (res.ok) {
//           const response = await res.json();
//           const allMilestones = response.milestones || response;
//           console.log('Force fetch - All milestones:', allMilestones);

//           const projectMilestones = Array.isArray(allMilestones) ? 
//             allMilestones.filter(m => {
//               const milestoneProjectId = m.project || m.projectId;
//               const matchesId = String(milestoneProjectId) === String(currentProjectId);
//               const matchesProjectRef = m.project && typeof m.project === 'object' && String(m.project._id) === String(currentProjectId);
//               return matchesId || matchesProjectRef;
//             }) : [];

//           console.log('Force fetch - Filtered milestones:', projectMilestones);
//           setLocalMilestones(projectMilestones);
//         }
//       } catch (error) {
//         console.error('Force fetch milestones error:', error);
//       }
//     };

//     forceFetchMilestones();
//   }, [currentProjectId]); // Run when ID changes

//   // Disabled background refetch to prevent milestone clearing
//   // useEffect(() => {
//   //   if (projects.length > 0 && id) {
//   //     console.log('Component mounted or projects loaded, refetching milestones...');
//   //     const timeoutId = setTimeout(() => {
//   //       // Background refetch logic disabled to prevent clearing milestones
//   //     }, 500);

//   //     return () => clearTimeout(timeoutId);
//   //   }
//   // }, [projects, id]);

//   console.log("Untitled Project", project);

//   // normalize team members: handle both new format (full objects) and old format (IDs only)
//   const teamMembers = useMemo(() => {
//     console.log('Team members mapping - Project teamMembers:', project?.teamMembers);
//     console.log('Team members mapping - Available employees:', employees?.length);
//     console.log('Cached employee details:', Object.keys(employeeDetails));

//     const list = project?.teamMembers || [];
//     return list.map((m, index) => {
//       console.log(`Processing team member ${index}:`, m);

//       if (!m) return { _id: 'unknown', name: 'Unknown', teamMemberName: 'Unknown', email: '', role: '' };

//       // Handle new format: team member is already a full object with name/role
//       if (typeof m === 'object' && m !== null && (m.name || m.teamMemberName)) {
//         console.log('✅ Team member object (new format):', m);
//         console.log('Available fields in team member:', Object.keys(m));

//         // Check if we have detailed employee data cached
//         const employeeId = m._id;
//         const detailedEmployee = employeeDetails[employeeId];

//         let position = 'Position not available';

//         if (detailedEmployee) {
//           console.log('✅ Using cached detailed employee data:', detailedEmployee);
//           position = detailedEmployee.role || 
//                     detailedEmployee.position || 
//                     detailedEmployee.designation || 
//                     detailedEmployee.jobTitle || 
//                     detailedEmployee.title || 
//                     detailedEmployee.employeePosition ||
//                     detailedEmployee.department ||
//                     'Position not available';
//         } else {
//           // Try from team member object first
//           position = m.role || 
//                     m.position || 
//                     m.designation || 
//                     m.jobTitle || 
//                     m.title || 
//                     m.employeePosition ||
//                     m.department ||
//                     'Position not available';
//         }

//         console.log('🎯 Resolved position for', m.name || m.teamMemberName, ':', position);

//         return {
//           _id: m._id || 'unknown',
//           name: m.teamMemberName || m.name || m.firstName || 'No Name',
//           teamMemberName: m.teamMemberName || m.name || m.firstName || 'No Name',
//           email: m.email || m.emailAddress || 'No Email',
//           role: position
//         };
//       }

//       // Handle old format: team member is just an ID string or object with only _id
//       const memberId = typeof m === 'string' ? m : m._id;
//       console.log('Looking up employee by ID:', memberId);

//       // First check cached detailed employee data
//       const detailedEmployee = employeeDetails[memberId];
//       if (detailedEmployee && detailedEmployee.isActive !== false) {
//         console.log('✅ Using cached detailed employee data for ID:', memberId);

//         const position = detailedEmployee.role || 
//                         detailedEmployee.position || 
//                         detailedEmployee.designation || 
//                         detailedEmployee.jobTitle || 
//                         detailedEmployee.title || 
//                         detailedEmployee.employeePosition ||
//                         detailedEmployee.department ||
//                         'Position not available';

//         console.log('🎯 Resolved position from detailed data:', position);

//         return {
//           _id: detailedEmployee._id,
//           name: detailedEmployee.teamMemberName || detailedEmployee.name || detailedEmployee.firstName || 'No Name',
//           teamMemberName: detailedEmployee.teamMemberName || detailedEmployee.name || detailedEmployee.firstName || 'No Name',
//           email: detailedEmployee.email || detailedEmployee.emailAddress || 'No Email',
//           role: position
//         };
//       }

//       // Fallback to existing employee list
//       if (memberId && employees && employees.length > 0) {
//         const found = employees.find(e => String(e._id) === String(memberId));
//         console.log('Employee lookup result:', !!found);

//         if (found) {
//           console.log('✅ Found employee data:', found);
//           console.log('Available fields in employee:', Object.keys(found));

//           // Try multiple position field names from employee data
//           const position = found.role || 
//                           found.position || 
//                           found.designation || 
//                           found.jobTitle || 
//                           found.title || 
//                           found.employeePosition ||
//                           found.department ||
//                           'Position not available';

//           console.log('🎯 Resolved position for employee', found.name || found.teamMemberName, ':', position);

//           return {
//             _id: found._id,
//             name: found.teamMemberName || found.name || found.firstName || 'No Name',
//             teamMemberName: found.teamMemberName || found.name || found.firstName || 'No Name',
//             email: found.email || found.emailAddress || 'No Email',
//             role: position
//           };
//         }
//       }

//       // Fallback for unknown format
//       const fallbackId = typeof m === 'string' ? m : (m._id || 'unknown');
//       console.log('⚠️ Using fallback for team member:', fallbackId);
//       return { 
//         _id: fallbackId, 
//         name: `Employee ID: ${fallbackId}`, 
//         teamMemberName: `Employee ID: ${fallbackId}`, 
//         email: '', 
//         role: 'Position not available' 
//       };
//     }).filter(Boolean);
//   }, [project, employees, employeeDetails]);

//   // helpers
//   const toDate = (d) => (d ? new Date(d) : null);
//   const fmtDate = (d) => {
//     if (!d) return 'N/A';
//     const date = new Date(d);
//     const day = String(date.getDate()).padStart(2, '0');
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const year = date.getFullYear();
//     return `${day}/${month}/${year}`;
//   };
//   const num = (v) => {
//     const n = typeof v === 'string' ? parseFloat(v) : v;
//     return Number.isFinite(n) ? n : 0;
//   };
//   const safePct = (v) => {
//     const n = Math.max(0, Math.min(100, Number(v) || 0));
//     return n;
//   };

//   // Calculate progress based on status position in statusOptions array
//   const getStatusProgress = (currentStatus, statusOptions) => {
//     if (!statusOptions || statusOptions.length === 0) {
//       // Fallback to default statuses if no custom statuses available
//       const defaultStatuses = ['Planning', 'In Progress', 'Completed'];
//       const statusIndex = defaultStatuses.findIndex(status => 
//         status.toLowerCase() === (currentStatus || '').toLowerCase()
//       );
//       const currentPosition = statusIndex >= 0 ? statusIndex + 1 : 1;
//       return {
//         current: currentPosition,
//         total: defaultStatuses.length,
//         percentage: Math.round((currentPosition / defaultStatuses.length) * 100)
//       };
//     }

//     const statusIndex = statusOptions.findIndex(status => 
//       status.toLowerCase() === (currentStatus || '').toLowerCase()
//     );
//     const currentPosition = statusIndex >= 0 ? statusIndex + 1 : 1;

//     return {
//       current: currentPosition,
//       total: statusOptions.length,
//       percentage: Math.round((currentPosition / statusOptions.length) * 100)
//     };
//   };

//   // Follow-Up form handlers
//   const handleFollowUpChange = (e) => {
//     setFollowUpFormData({
//       ...followUpFormData,
//       [e.target.name]: e.target.value
//     });
//   };


//   const handleFollowUpSubmit = async (e) => {
//     e.preventDefault();

//     if (!followUpFormData.title || !followUpFormData.dueDate) {
//       setShowAlert('Please fill in all required fields (Title and Due Date)');
//       return;
//     }

//     // Get company ID from JWT token
//     const authToken = localStorage.getItem('authToken');
//     let companyId = '';

//     if (authToken) {
//       try {
//         const decodedToken = jwtDecode(authToken);
//         // companyId = decodedToken.companyId;
//         companyId=  decodedToken.role === 'company' 
//         ? (decodedToken.companyId || decodedToken.id) 
//         : decodedToken.companyId;



//       } catch (err) {
//         console.error("Error decoding token:", err);
//       }
//     }
// console.log("followUpFormData",followUpFormData);

//     const newMilestone = {
//       title: followUpFormData.title,
//       project: project._id, // Server expects 'project' field (as per error message)
//       projectName: project.title || project.name, // Keep projectName for compatibility
//       description: followUpFormData.description,
//       dueDate: followUpFormData.dueDate, // Send as string, let server parse
//       status: followUpFormData.status || 'Pending',
//       assignedTeamMember: followUpFormData.assignedTeamMember.length > 0 ? followUpFormData.assignedTeamMember : undefined,
//       nextFollowUp: followUpFormData.nextFollowUp || undefined,
//       company: companyId // Server might expect 'company' instead of 'companyId'
//     };

//     try {
//       // Use the same endpoint that works for fetching milestones
//       console.log('Creating milestone with data:', JSON.stringify(newMilestone, null, 2));

//       const res = await fetch('https://crm-tkxn.onrender.com/api/milestones', {
//         method: 'POST',
//         headers: { 
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${authToken}`
//         },
//         body: JSON.stringify(newMilestone)
//       });

//       if (res.ok) {
//         const created = await res.json();
//         console.log('Milestone created successfully:', created);
//         console.log('Created milestone projectName:', created.milestone?.projectName);
//         console.log('Current project name:', project.title || project.name);

//         // Update local state immediately - use the actual milestone object
//         const actualMilestone = created.milestone || created;
//         console.log('Adding milestone to local state:', actualMilestone);

//         // Add immediate feedback to user
//         console.log('✅ Project-Task created successfully! Updating UI...');

//         // Add milestone immediately to UI for instant feedback
//         const tempMilestone = {
//           ...actualMilestone,
//           _id: actualMilestone._id || Date.now().toString(),
//           project: project._id, // Ensure project ID is set
//           projectId: project._id, // Also set projectId for compatibility
//           projectName: project.title || project.name,
//           title: actualMilestone.title || followUpFormData.title,
//           status: actualMilestone.status || followUpFormData.status || 'Pending',
//           dueDate: actualMilestone.dueDate || followUpFormData.dueDate,
//           description: actualMilestone.description || followUpFormData.description,
//           assignedTeamMember: actualMilestone.assignedTeamMember || followUpFormData.assignedTeamMember,
//           nextFollowUp: actualMilestone.nextFollowUp || followUpFormData.nextFollowUp
//         };

//         console.log('✅ Adding milestone to UI immediately:', tempMilestone);
//         setLocalMilestones(prev => {
//           console.log('📋 Previous milestones:', prev.length);
//           const updated = [...prev, tempMilestone];
//           console.log('📋 Updated milestones:', updated.length);
//           return updated;
//         });

//         // Reset form immediately
//         setFollowUpFormData({
//           title: '',
//           projectName: '',
//           description: '',
//           dueDate: '',
//           status: 'Pending',
//           assignedTeamMember: [],
//           nextFollowUp: ''
//         });
//         setShowFollowUpForm(false);

//         // Force a refetch to get the actual data from server after a short delay
//         console.log('„ Milestone created, refetching from server for real-time sync...');
//         setTimeout(async () => {
//           try {
//             console.log('„ Fetching latest milestones from server...');
//             const fetchRes = await fetch('https://crm-tkxn.onrender.com/api/milestones', {
//               headers: { 'Authorization': `Bearer ${authToken}` }
//             });
//             if (fetchRes.ok) {
//               const response = await fetchRes.json();
//               console.log('All milestones from API after creation:', response);
//               const allMilestones = response.milestones || response;
//               const currentProjectId = project._id;
//               const currentProjectName = project.title || project.name;
//               console.log('Filtering for project ID:', currentProjectId, 'and name:', currentProjectName);

//               const projectMilestones = Array.isArray(allMilestones) ? 
//                 allMilestones.filter(m => {
//                   // Filter by project ID (most reliable)
//                   const milestoneProjectId = m.project || m.projectId;
//                   const matchesId = String(milestoneProjectId) === String(currentProjectId);

//                   // Also check by project name as fallback
//                   const matchesName = m.projectName === currentProjectName;

//                   // Additional check for project reference object
//                   const matchesProjectRef = m.project && typeof m.project === 'object' && String(m.project._id) === String(currentProjectId);

//                   const finalMatch = matchesId || matchesName || matchesProjectRef;

//                   console.log(`Milestone "${m.title}":`, {
//                     projectId: milestoneProjectId,
//                     matchesId,
//                     projectName: m.projectName,
//                     matchesName,
//                     projectRef: m.project,
//                     matchesProjectRef,
//                     finalMatch
//                   });

//                   return finalMatch;
//                 }) : [];
//               console.log('Refetched milestones after creation:', projectMilestones);
//               setLocalMilestones(projectMilestones);

//               // Also refresh other components that might show milestones
//               if (window.refreshMilestones) {
//                 window.refreshMilestones();
//               }
//               if (window.refreshProjectTracker) {
//                 window.refreshProjectTracker();
//               }
//             }
//           } catch (error) {
//             console.error('Error refetching after creation:', error);
//           }
//         }, 500); // Reduced timeout for faster update
//       } else {
//         console.error('Failed to create milestone:', res.status, res.statusText);
//         try {
//           const errorText = await res.text();
//           console.error('Error response:', errorText);
//           setShowAlert(`Failed to create milestone: ${res.status} ${res.statusText}\n${errorText}`);
//         } catch (e) {
//           setShowAlert(`Failed to create milestone: ${res.status} ${res.statusText}`);
//         }
//       }
//     } catch (error) {
//       console.error('Error creating milestone:', error);
//     }
//   };


//   // Milestone management functions
//   const handleStatusChange = async (milestoneId, newStatus) => {
//     if (!milestoneId) {
//       console.error('Milestone ID is undefined, cannot update status');
//       return;
//     }

//     try {
//       const authToken = localStorage.getItem('authToken');

//       // Use the standardized milestone API endpoint
//       const res = await fetch(`https://crm-tkxn.onrender.com/api/milestones/${milestoneId}`, {
//         method: 'PUT',
//         headers: { 
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${authToken}`
//         },
//         body: JSON.stringify({ status: newStatus })
//       });

//       if (res.ok) {
//         const updated = await res.json();
//         setLocalMilestones(prev =>
//           prev.map(m => ((m._id || m.id) === milestoneId ? { ...m, status: newStatus } : m))
//         );
//         console.log(`Milestone status updated to: ${newStatus}`);
//       } else {
//         console.error('Failed to update milestone:', res.status);
//         setShowAlert('Failed to update milestone status. Please try again.');
//       }
//     } catch (error) {
//       console.error('Failed to update milestone:', error);
//       setShowAlert('Error updating milestone status. Please try again.');
//     }
//   };

//   const handleDelete = async (milestoneId) => {
//     if (!milestoneId) {
//       console.error('Milestone ID is undefined, cannot delete');
//       return;
//     }

//     if (!window.confirm('Are you sure you want to delete this milestone?')) return;

//     try {
//       const authToken = localStorage.getItem('authToken');

//       // Use the standardized milestone API endpoint
//       const res = await fetch(`https://crm-tkxn.onrender.com/api/milestones/${milestoneId}`, {
//         method: 'DELETE',
//         headers: {
//           'Authorization': `Bearer ${authToken}`
//         }
//       });

//       if (res.ok) {
//         setLocalMilestones(prev => prev.filter(m => (m._id || m.id) !== milestoneId));
//         console.log('Milestone deleted successfully');
//       } else {
//         console.error('Failed to delete milestone:', res.status);
//         setShowAlert('Failed to delete milestone. Please try again.');
//       }
//     } catch (error) {
//       console.error('Failed to delete milestone:', error);
//       setShowAlert('Error deleting milestone. Please try again.');
//     }
//   };


//   if (!project) {
//     if (projectLoading) {
//       return (
//         <div style={projectViewStyle}>
//           <div style={pageHeaderStyle}>
//             <h1 style={headerTitleStyle}>Loading Project...</h1>
//           </div>
//           <div style={emptyStateStyle}>
//             <div style={{ fontSize: "2rem", marginBottom: "1rem" }}></div>
//             Loading project details...
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div style={projectViewStyle}>
//         <div style={pageHeaderStyle}>
//           <button 
//             onClick={(e) => {
//               e.preventDefault();
//               e.stopPropagation();
//               console.log('™ Back button clicked (error state)');
//               if (onNavigate) {
//                 console.log('✅ Using onNavigate callback');
//                 onNavigate('/projects', 'Projects');
//               } else if (navigate) {
//                 console.log('✅ Fallback: Using navigate from React Router');
//                 navigate('/projects');
//               }
//             }}
//             style={{
//               ...btnSecondaryStyle,
//               ':hover': {
//                 background: '#e9ecef',
//                 transform: 'translateY(-2px)'
//               }
//             }}
//             onMouseEnter={(e) => {
//               e.target.style.background = '#e9ecef';
//               e.target.style.transform = 'translateY(-2px)';
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.background = '#f8f9fa';
//               e.target.style.transform = 'translateY(0px)';
//             }}
//           >
//             <ArrowLeft size={20} />
//             Back to Projects
//           </button>
//           <h1 style={headerTitleStyle}>Project Not Found</h1>
//         </div>
//         <div style={emptyStateStyle}>
//           <div style={{ fontSize: "1rem", marginBottom: "1rem", color: '#666' }}>
//             Debug info - Current Project ID: {currentProjectId} | Projects in array: {projects.length}
//           </div>
//           The requested project could not be found.
//         </div>
//       </div>
//     );
//   }

//   const budget = num(project.budget);
//   const progressData = getStatusProgress(project.status, statusOptions);
//   const progress = progressData.percentage; // For progress bar width
//   const start = toDate(project.startDate);
//   const due = toDate(project.dueDate);

//   return (
//     <div style={projectViewStyle}>
//       {/* Export Button */}
//       <button
//         style={{
//           ...exportButtonStyle,
//           ...(hoveredExport ? exportButtonHoverStyle : {})
//         }}
//         onMouseEnter={() => setHoveredExport(true)}
//         onMouseLeave={() => setHoveredExport(false)}
//         onClick={exportToPDF}
//       >
//         <Download size={10} />
//         Export PDF
//       </button>

//       <div style={pageHeaderStyle}>
//         <button 
//           onClick={(e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     console.log('™ Back button clicked in ProjectView - event prevented');
//     console.log('onNavigate available?', !!onNavigate, 'navigate available?', !!navigate);

//     // Try onNavigate first (for FranchiseDashboard internal routing)
//     if (onNavigate) {
//       console.log('✅ Using onNavigate callback');
//       onNavigate('/projects', 'Projects');
//     } 
//     // Fallback to React Router navigation
//     else if (navigate) {
//       console.log('✅ Fallback: Using navigate from React Router');
//       navigate('/projects');
//     } 
//     else {
//       console.error('❌ Neither onNavigate nor navigate available');
//     }
//   }}
//           style={{
//             ...btnSecondaryStyle,
//             ':hover': {
//               background: '#e9ecef',
//               transform: 'translateY(-2px)'
//             }
//           }}
//           onMouseEnter={(e) => {
//             e.target.style.background = '#e9ecef';
//             e.target.style.transform = 'translateY(-2px)';
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.background = 'f8f9fa';
//             e.target.style.transform = 'translateY(0px)';
//           }}
//         >
//           <ArrowLeft size={20} />
//           Back to Projects
//         </button>
//         <h1 style={headerTitleStyle}>
//           <Sparkles size={32} style={{ color: '#667eea' }} />
//           {project.title || project.name || 'Untitled Project'}
//         </h1>
//       </div>

//       {/* Description */}
//       <div style={cardStyle}>
//         <h3 style={sectionTitleStyle}> Description</h3>
//         <p style={{ fontSize: '1.2rem', color: '#495057', lineHeight: 1.7, margin: 0 }}>
//           {project.description || 'No description provided.'}
//         </p>
//       </div>

//       {/* Department Section */}
//       {project.department || (project.department && project.department.length > 0) ? (
//         <div style={cardStyle}>
//           <h3 style={sectionTitleStyle}><Building2 size={24} /> Department</h3>
//           <div style={projectMetaGrid}>
//             {project.department && Array.isArray(project.department) ? (
//               project.department.map((dept, idx) => {
//                 // If dept is an object, use its name, otherwise find by ID
//                 let deptName = 'Unknown Department';
//                 if (typeof dept === 'object' && dept.name) {
//                   deptName = dept.name;
//                 } else if (typeof dept === 'string') {
//                   const foundDept = department.find(d => d._id === dept || d.id === dept);
//                   deptName = foundDept ? (foundDept.name || foundDept.departmentName || 'Unknown Department') : dept;
//                 }
//                 return (
//                   <div 
//                     key={idx} 
//                     style={metaItemStyle}
//                     onMouseEnter={(e) => {
//                       e.currentTarget.style.transform = 'translateY(-3px)';
//                       e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.transform = 'translateY(0px)';
//                       e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//                     }}
//                   >
//                     <Building2 style={metaIconStyle} />
//                     <div>
//                       <p style={metaLabelStyle}>Department</p>
//                       <p style={metaValueStyle}>{deptName}</p>
//                     </div>
//                   </div>
//                 );
//               })
//             ) : (
//               <div 
//                 style={metaItemStyle}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-3px)';
//                   e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0px)';
//                   e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//                 }}
//               >
//                 <Building2 style={metaIconStyle} />
//                 <div>
//                   <p style={metaLabelStyle}>Department</p>
//                   <p style={metaValueStyle}>
//                     {(() => {
//                       if (typeof project.department === 'object' && project.department.name) {
//                         return project.department.name;
//                       } else if (typeof project.department === 'string') {
//                         const foundDept = department.find(d => d._id === project.department || d.id === project.department);
//                         return foundDept ? (foundDept.name || foundDept.departmentName || 'Unknown Department') : project.department;
//                       }
//                       return 'Unknown Department';
//                     })()}
//                   </p>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       ) : null}

//       {/* Project Head */}
//       {project.projectHead && (
//         <div style={cardStyle}>
//           <h3 style={sectionTitleStyle}>
//             💼 Project Head
//           </h3>
//           <div style={teamCardStyle}>
//             {(() => {
//               // Find project head details from employees
//               let projectHeadDetails = null;
//               const projectHeadId = typeof project.projectHead === 'string' ? project.projectHead : project.projectHead?._id;

//               // First check cached detailed employee data
//               const detailedProjectHead = employeeDetails[projectHeadId];
//               if (detailedProjectHead) {
//                 console.log('✅ Using cached detailed project head data:', detailedProjectHead);
//                 projectHeadDetails = detailedProjectHead;
//               } else if (typeof project.projectHead === 'object' && (project.projectHead.name || project.projectHead.teamMemberName)) {
//                 projectHeadDetails = project.projectHead;
//               } else if (typeof project.projectHead === 'string' && employees.length > 0) {
//                 projectHeadDetails = employees.find(emp => String(emp._id) === String(project.projectHead));
//               }

//               if (projectHeadDetails) {
//                 // Get position with comprehensive field checking
//                 const position = projectHeadDetails.role || 
//                                 projectHeadDetails.position || 
//                                 projectHeadDetails.designation || 
//                                 projectHeadDetails.jobTitle || 
//                                 projectHeadDetails.title || 
//                                 projectHeadDetails.employeePosition ||
//                                 projectHeadDetails.department ||
//                                 'Position not available';

//                 console.log('🎯 Project Head position resolved:', position);

//                 return (
//                   <div>
//                     <p style={{
//                       fontWeight: 700,
//                       margin: "0 0 8px 0",
//                       color: "#333",
//                       fontSize: "1.1rem",
//                     }}>
//                       {projectHeadDetails.teamMemberName || projectHeadDetails.name || 'Unknown'}
//                     </p>
//                     {projectHeadDetails.email && (
//                       <p style={{
//                         margin: "0 0 6px 0",
//                         fontSize: "0.9rem",
//                         color: "#6c757d",
//                       }}>
//                          {projectHeadDetails.email}
//                       </p>
//                     )}
//                     <p style={{
//                       margin: "6px 0 0 0",
//                       fontSize: "0.8rem",
//                       color: "#6c757d",
//                       fontWeight: 600,
//                     }}>
//                       💼 {position}
//                     </p>
//                   </div>
//                 );
//               } else {
//                 return (
//                   <p style={{ color: "#6c757d", fontStyle: "italic" }}>
//                     Project Head ID: {String(project.projectHead)}
//                   </p>
//                 );
//               }
//             })()}
//           </div>
//         </div>
//       )}

//       {/* Team Members */}
//       <div style={cardStyle}>
//         <h3 style={sectionTitleStyle}>
//           <Users size={24} /> Team Members
//         </h3>

//         {teamMembers.length > 0 ? (
//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
//               gap: "1rem",
//             }}
//           >
//             {teamMembers.map((member, index) => (
//               <div 
//                 key={member._id || index} 
//                 style={teamCardStyle}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-3px)';
//                   e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0px)';
//                   e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//                 }}
//               >
//                 <p
//                   style={{
//                     fontWeight: 700,
//                     margin: "0 0 8px 0",
//                     color: "#333",
//                     fontSize: "1.1rem",
//                   }}
//                 >
//                   {member.teamMemberName || member.name}
//                 </p>
//                 {member.email && (
//                   <p
//                     style={{
//                       margin: "0 0 6px 0",
//                       fontSize: "0.9rem",
//                       color: "#6c757d",
//                     }}
//                   >
//                      {member.email}
//                   </p>
//                 )}
//                 <p
//                   style={{
//                     margin: "6px 0 0 0",
//                     fontSize: "0.8rem",
//                     color: "#6c757d",
//                     fontWeight: 600,
//                   }}
//                 >
//                   💼 {member.role || 'Position not available'}
//                 </p>
//               </div>
//             ))}
//           </div>
//         ) : (
//           <div style={emptyStateStyle}>No team members added.</div>
//         )}
//       </div>

//       {/* Meta: dates, budget, status, progress */}
//       <div style={cardStyle}>
//         <h3 style={sectionTitleStyle}>📊 Project Overview</h3>
//         <div style={projectMetaGrid}>
//           <div 
//             style={metaItemStyle}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.transform = 'translateY(-3px)';
//               e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.transform = 'translateY(0px)';
//               e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//             }}
//           >
//             <Calendar style={metaIconStyle} />
//             <div>
//               <p style={metaLabelStyle}>Start Date</p>
//               <p style={metaValueStyle}>{fmtDate(start)}</p>
//             </div>
//           </div>

//           <div 
//             style={metaItemStyle}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.transform = 'translateY(-3px)';
//               e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.transform = 'translateY(0px)';
//               e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//             }}
//           >
//             <Calendar style={metaIconStyle} />
//             <div>
//               <p style={metaLabelStyle}>Due Date</p>
//               <p style={metaValueStyle}>{fmtDate(due)}</p>
//             </div>
//           </div>

//           <div 
//             style={metaItemStyle}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.transform = 'translateY(-3px)';
//               e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.transform = 'translateY(0px)';
//               e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//             }}
//           >
//             <IndianRupee style={metaIconStyle} />
//             <div>
//               <p style={metaLabelStyle}>Budget</p>
//               <p style={metaValueStyle}>
//                 ₹{budget.toLocaleString('en-IN')}
//               </p>
//             </div>
//           </div>

//           <div 
//             style={metaItemStyle}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.transform = 'translateY(-3px)';
//               e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.transform = 'translateY(0px)';
//               e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//             }}
//           >
//             <Target style={metaIconStyle} />
//             <div>
//               <p style={metaLabelStyle}>Status</p>
//               <span style={getStatusBadgeStyle(project.status)}>{project.status || 'Unknown'}</span>
//             </div>
//           </div>

//           <div 
//             style={{ ...metaItemStyle, gridColumn: '1 / -1' }}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.transform = 'translateY(-3px)';
//               e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.transform = 'translateY(0px)';
//               e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//             }}
//           >
//             <BarChart3 style={metaIconStyle} />
//             <div style={{ flex: 1 }}>
//               <p style={metaLabelStyle}>Progress</p>
//               <div style={progressTrack}>
//                 <div style={progressFill(progress)} />
//               </div>
//               <p style={{ ...metaValueStyle, marginTop: 6 }}>{progressData.percentage}/100</p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Client Info */}
//       {(project.clientName || project.clientCompany || project.clientEmail || project.clientMobileNo || project.clientAddress || project.clientCity || project.clientState) && (
//         <div style={cardStyle}>
//           <h3 style={sectionTitleStyle}>Client Information</h3>
//           <div style={projectMetaGrid}>
//             {project.clientName && (
//               <div 
//                 style={metaItemStyle}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-3px)';
//                   e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0px)';
//                   e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//                 }}
//               >
//                 <span style={{ ...metaIconStyle, fontSize: '1.1rem' }}></span>
//                 <div>
//                   <p style={metaLabelStyle}>Name</p>
//                   <p style={metaValueStyle}>{project.clientName}</p>
//                 </div>
//               </div>
//             )}
//             {project.clientCompany && (
//               <div 
//                 style={metaItemStyle}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-3px)';
//                   e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0px)';
//                   e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//                 }}
//               >
//                 <Building2 style={metaIconStyle} />
//                 <div>
//                   <p style={metaLabelStyle}>Company</p>
//                   <p style={metaValueStyle}>{project.clientCompany}</p>
//                 </div>
//               </div>
//             )}
//             {project.clientEmail && (
//               <div 
//                 style={metaItemStyle}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-3px)';
//                   e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0px)';
//                   e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//                 }}
//               >
//                 <Mail style={metaIconStyle} />
//                 <div>
//                   <p style={metaLabelStyle}>Email</p>
//                   <p style={metaValueStyle}>{project.clientEmail}</p>
//                 </div>
//               </div>
//             )}
//             {project.clientMobileNo && (
//               <div 
//                 style={metaItemStyle}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-3px)';
//                   e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0px)';
//                   e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//                 }}
//               >
//                 <Phone style={metaIconStyle} />
//                 <div>
//                   <p style={metaLabelStyle}>Mobile</p>
//                   <p style={metaValueStyle}>{project.clientMobileNo}</p>
//                 </div>
//               </div>
//             )}
//             {project.clientAddress && (
//               <div 
//                 style={{...metaItemStyle, gridColumn: '1 / -1'}}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-3px)';
//                   e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0px)';
//                   e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//                 }}
//               >
//                 <span style={{ ...metaIconStyle, fontSize: '1.1rem' }}> </span>
//                 <div>
//                   <p style={metaLabelStyle}>Address</p>
//                   <p style={metaValueStyle}>{project.clientAddress}</p>
//                 </div>
//               </div>
//             )}
//             {project.clientCity && (
//               <div 
//                 style={metaItemStyle}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-3px)';
//                   e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0px)';
//                   e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//                 }}
//               >
//                 <span style={{ ...metaIconStyle, fontSize: '1.1rem' }}>™ï</span>
//                 <div>
//                   <p style={metaLabelStyle}>City</p>
//                   <p style={metaValueStyle}>{project.clientCity}</p>
//                 </div>
//               </div>
//             )}
//             {project.clientState && (
//               <div 
//                 style={metaItemStyle}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-3px)';
//                   e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0px)';
//                   e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//                 }}
//               >
//                 <span style={{ ...metaIconStyle, fontSize: '1.1rem' }}>—ï</span>
//                 <div>
//                   <p style={metaLabelStyle}>State</p>
//                   <p style={metaValueStyle}>{project.clientState}</p>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       )}

//       {/* Custom Fields */}
//       {project.customFields && project.customFields.length > 0 && (
//         <div style={cardStyle}>
//           <h3 style={sectionTitleStyle}>š™ï Other Information</h3>
//           <div style={projectMetaGrid}>
//             {project.customFields.map((field, index) => (
//               <div 
//                 key={index}
//                 style={metaItemStyle}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-3px)';
//                   e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0px)';
//                   e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//                 }}
//               >
//                 <span style={{ ...metaIconStyle, fontSize: '1.1rem' }}>🔧</span>
//                 <div>
//                   <p style={metaLabelStyle}>{field.key}</p>
//                   <p style={metaValueStyle}>{field.value}</p>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       )}

//       {/* Timeline */}
//       <div style={cardStyle}>
//         <h3 style={sectionTitleStyle}><Clock size={24} /> Project Timeline</h3>
//         <div style={projectMetaGrid}>
//           <div 
//             style={metaItemStyle}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.transform = 'translateY(-3px)';
//               e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.transform = 'translateY(0px)';
//               e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//             }}
//           >
//             <span style={{ ...metaIconStyle, fontSize: '1.25rem' }}>…</span>
//             <div>
//               <p style={metaLabelStyle}>Created</p>
//               <p style={metaValueStyle}>{project.createdAt ? new Date(project.createdAt).toLocaleString() : 'N/A'}</p>
//             </div>
//           </div>
//           <div 
//             style={metaItemStyle}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.transform = 'translateY(-3px)';
//               e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.transform = 'translateY(0px)';
//               e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//             }}
//           >
//             <span style={{ ...metaIconStyle, fontSize: '1.25rem' }}>„</span>
//             <div>
//               <p style={metaLabelStyle}>Last Updated</p>
//               <p style={metaValueStyle}>{project.updatedAt ? new Date(project.updatedAt).toLocaleString() : 'N/A'}</p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Follow-Ups */}
//       <div style={cardStyle}>
//         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
//           <h3 style={sectionTitleStyle}>📋 Project-Task</h3>
//           <div style={{ display: 'flex', gap: '0.5rem' }}>
//             <button
//               onClick={refreshMilestones}
//               style={{
//                 ...btnSecondaryStyle,
//                 padding: '0.5rem 1rem',
//                 fontSize: '0.8rem'
//               }}
//               title="Refresh Project-Tasks"
//             >
//               „ Refresh
//             </button>
//             <button
//               onClick={() => {
//                 if (!showFollowUpForm) {
//                   // Auto-populate form when opening
//                   // Use a more appropriate default status
//                   let defaultStatus = 'Pending';
//                   if (statusOptions.length > 0) {
//                     // Try to find common default statuses in order of preference
//                     const preferredDefaults = ['Planning', 'To Do', 'Pending', 'Not Started'];
//                     const foundDefault = preferredDefaults.find(status => 
//                       statusOptions.some(option => option.toLowerCase() === status.toLowerCase())
//                     );
//                   defaultStatus = foundDefault || statusOptions[0];
//                 }
//                 console.log('ProjectView - Setting default status for new sub-task:', defaultStatus);
//                 console.log('ProjectView - Available status options:', statusOptions);
//                 setFollowUpFormData({
//                   title: '',
//                   projectName: project.title || project.name || '',
//                   description: '',
//                   dueDate: '',
//                   status: defaultStatus,
//                   assignedTeamMember: [],
//                   nextFollowUp: ''
//                 });
//               }
//               setShowFollowUpForm(!showFollowUpForm);
//             }}
//             style={{
//               ...btnStyle,
//               backgroundColor: showFollowUpForm ? '#ef4444' : '#10b981',
//               color: 'white',
//               fontSize: '0.875rem',
//               padding: '0.5rem 1rem'
//             }}
//             onMouseEnter={(e) => {
//               e.target.style.transform = 'translateY(-2px)';
//               e.target.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)';
//             }}
//             onMouseLeave={(e) => {
//               e.target.style.transform = 'translateY(0px)';
//               e.target.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
//             }}
//           >
//             {showFollowUpForm ? (
//               <>
//                 <X size={16} />
//                 Cancel
//               </>
//             ) : (
//               <>
//                 <Plus size={16} />
//                 Add Project-Task
//               </>
//             )}
//           </button>
//           </div>
//         </div>

//         {/* Follow-Up Form */}
//         {showFollowUpForm && (
//           <div style={{
//             backgroundColor: '#f8fafc',
//             border: '1px solid #e2e8f0',
//             borderRadius: '8px',
//             padding: '1.5rem',
//             marginBottom: '1rem',
//             maxWidth: '600px',
//             margin: '0 auto 1rem auto'
//           }}>
//             <form onSubmit={handleFollowUpSubmit}>
//               <div style={{ marginBottom: '1.5rem' }}>
//                 <label htmlFor="title" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#374151' }}>
//                 Project-Task Title *
//                 </label>
//                 <input
//                   type="text"
//                   id="title"
//                   name="title"
//                   value={followUpFormData.title}
//                   onChange={handleFollowUpChange}
//                   placeholder="Enter Project-Task title"
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '0.75rem',
//                     border: '1px solid #d1d5db',
//                     borderRadius: '0.5rem',
//                     fontSize: '1rem',
//                     outline: 'none',
//                     transition: 'border-color 0.2s ease'
//                   }}
//                 />
//               </div>

//               <div style={{ marginBottom: '1.5rem' }}>
//                 <label htmlFor="description" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#374151' }}>
//                   Description
//                 </label>
//                 <textarea
//                   id="description"
//                   name="description"
//                   value={followUpFormData.description}
//                   onChange={handleFollowUpChange}
//                   placeholder="Enter Project-Tasks description"
//                   rows="3"
//                   style={{
//                     width: '100%',
//                     padding: '0.75rem',
//                     border: '1px solid #d1d5db',
//                     borderRadius: '0.5rem',
//                     fontSize: '1rem',
//                     outline: 'none',
//                     transition: 'border-color 0.2s ease',
//                     resize: 'vertical',
//                     minHeight: '80px'
//                   }}
//                 />
//               </div>

//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', marginBottom: '1.5rem' }}>
//                 <div>
//                   <label htmlFor="dueDate" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#374151' }}>
//                     Due Date *
//                   </label>
//                   <input
//                     type="date"
//                     id="dueDate"
//                     name="dueDate"
//                     value={followUpFormData.dueDate}
//                     onChange={handleFollowUpChange}
//                     required
//                     style={{
//                       width: '100%',
//                       padding: '0.75rem',
//                       border: '1px solid #d1d5db',
//                       borderRadius: '0.5rem',
//                       fontSize: '1rem',
//                       outline: 'none',
//                       transition: 'border-color 0.2s ease'
//                     }}
//                   />
//                 </div>

//                 <div>
//                   <label htmlFor="status" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#374151' }}>
//                     Status
//                   </label>
//                   <select
//                     id="status"
//                     name="status"
//                     value={followUpFormData.status}
//                     onChange={handleFollowUpChange}
//                     style={{
//                       width: '100%',
//                       padding: '0.75rem',
//                       border: '1px solid #d1d5db',
//                       borderRadius: '0.5rem',
//                       fontSize: '1rem',
//                       outline: 'none',
//                       cursor: 'pointer',
//                       transition: 'border-color 0.2s ease'
//                     }}
//                   >
//                     <option value="">
//                       {statusOptions.length > 0 
//                         ? "-- Select Status --" 
//                         : "-- Loading statuses... --"}
//                     </option>
//                     {statusOptions.map(opt => (
//                       <option key={opt} value={opt}>{opt}</option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '3rem', marginBottom: '1.5rem' }}>
//                 <div>
//                   <label htmlFor="assignedTeamMember" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#374151' }}>
//                     Assigned Team Members 
//                   </label>

//                   {/* Multi-select dropdown */}
//                   <div style={{ position: 'relative' }} data-team-dropdown-container>
//                     <div
//                       onClick={() => setOpenTeamMemberDropdown(!openTeamMemberDropdown)}
//                       style={{
//                         width: '100%',
//                         padding: '0.75rem',
//                         border: '1px solid #d1d5db',
//                         borderRadius: '0.5rem',
//                         fontSize: '1rem',
//                         cursor: 'pointer',
//                         backgroundColor: 'white',
//                         display: 'flex',
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         minHeight: '3rem'
//                       }}
//                     >
//                       <span style={{ color: followUpFormData.assignedTeamMember.length > 0 ? '#374151' : '#9ca3af' }}>
//                         {followUpFormData.assignedTeamMember.length > 0 
//                           ? `${followUpFormData.assignedTeamMember.length} team member(s) selected`
//                           : 'Select team members'
//                         }
//                       </span>
//                       <span style={{ fontSize: '12px', color: '#6b7280' }}>–</span>
//                     </div>

//                     {/* Dropdown Menu */}
//                     {openTeamMemberDropdown && (
//                       <div style={{
//                         position: 'absolute',
//                         top: '100%',
//                         left: '0',
//                         right: '0',
//                         backgroundColor: 'white',
//                         border: '1px solid #e5e7eb',
//                         borderRadius: '0.5rem',
//                         boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
//                         zIndex: 1000,
//                         maxHeight: '12rem',
//                         overflowY: 'auto',
//                         marginTop: '0.25rem'
//                       }}>
//                         {teamMembers && teamMembers.map((member, index) => (
//                           <div
//                             key={member._id}
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               const isSelected = followUpFormData.assignedTeamMember.includes(member._id);
//                               if (isSelected) {
//                                 // Remove from selection
//                                 setFollowUpFormData(prev => ({
//                                   ...prev,
//                                   assignedTeamMember: prev.assignedTeamMember.filter(id => id !== member._id)
//                                 }));
//                               } else {
//                                 // Add to selection
//                                 setFollowUpFormData(prev => ({
//                                   ...prev,
//                                   assignedTeamMember: [...prev.assignedTeamMember, member._id]
//                                 }));
//                               }
//                             }}
//                             style={{
//                               padding: '0.75rem',
//                               cursor: 'pointer',
//                               borderBottom: index < teamMembers.length - 1 ? '1px solid #f3f4f6' : 'none',
//                               display: 'flex',
//                               alignItems: 'center',
//                               gap: '0.5rem',
//                               backgroundColor: followUpFormData.assignedTeamMember.includes(member._id) ? '#f0f9ff' : 'transparent',
//                               transition: 'background-color 0.2s ease'
//                             }}
//                             onMouseEnter={(e) => {
//                               if (!followUpFormData.assignedTeamMember.includes(member._id)) {
//                                 e.target.style.backgroundColor = '#f9fafb';
//                               }
//                             }}
//                             onMouseLeave={(e) => {
//                               if (!followUpFormData.assignedTeamMember.includes(member._id)) {
//                                 e.target.style.backgroundColor = 'transparent';
//                               }
//                             }}
//                           >
//                             <input
//                               type="checkbox"
//                               checked={followUpFormData.assignedTeamMember.includes(member._id)}
//                               onChange={() => {}} // Handled by parent div onClick
//                               style={{ cursor: 'pointer' }}
//                             />
//                             <span style={{ 
//                               fontSize: '0.9rem', 
//                               color: '#374151',
//                               fontWeight: followUpFormData.assignedTeamMember.includes(member._id) ? 600 : 400
//                             }}>
//                               {member.teamMemberName || member.name || 'Unnamed'} - {member.role || 'No Position'}
//                             </span>
//                             {followUpFormData.assignedTeamMember.includes(member._id) && (
//                               <span style={{ marginLeft: 'auto', color: '#10b981', fontSize: '0.9rem' }}>✅</span>
//                             )}
//                           </div>
//                         ))}

//                         {(!teamMembers || teamMembers.length === 0) && (
//                           <div style={{ color: '#6b7280', fontSize: '0.9rem', padding: '0.75rem' }}>
//                             No team members available
//                           </div>
//                         )}
//                       </div>
//                     )}
//                   </div>

//                   {/* Selected employees display */}
//                   {followUpFormData.assignedTeamMember.length > 0 && (
//                     <div style={{ marginTop: '0.5rem' }}>
//                       <div style={{ fontSize: '0.8rem', color: '#6b7280', marginBottom: '0.25rem' }}>
//                         Selected ({followUpFormData.assignedTeamMember.length}):
//                       </div>
//                       <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem' }}>
//                         {followUpFormData.assignedTeamMember.map(memberId => {
//                           const member = teamMembers?.find(m => m._id === memberId);
//                           return member ? (
//                             <span key={memberId} style={{
//                               backgroundColor: '#dbeafe',
//                               color: '#1e40af',
//                               padding: '0.2rem 0.5rem',
//                               borderRadius: '0.375rem',
//                               fontSize: '0.8rem',
//                               display: 'flex',
//                               alignItems: 'center',
//                               gap: '0.25rem'
//                             }}>
//                               {member.teamMemberName || member.name || 'Unnamed'}
//                               <button
//                                 type="button"
//                                 onClick={() => {
//                                   setFollowUpFormData(prev => ({
//                                     ...prev,
//                                     assignedTeamMember: prev.assignedTeamMember.filter(id => id !== memberId)
//                                   }));
//                                 }}
//                                 style={{
//                                   background: 'none',
//                                   border: 'none',
//                                   color: '#1e40af',
//                                   cursor: 'pointer',
//                                   fontSize: '0.8rem',
//                                   padding: '0',
//                                   lineHeight: 1
//                                 }}
//                               >
//                                 Ã—
//                               </button>
//                             </span>
//                           ) : null;
//                         })}
//                       </div>
//                     </div>
//                   )}
//                 </div>

//                 <div>
//                   <label htmlFor="nextFollowUp" style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 500, color: '#374151' }}>
//                     Next Follow-Up Date
//                   </label>
//                   <input
//                     type="date"
//                     id="nextFollowUp"
//                     name="nextFollowUp"
//                     value={followUpFormData.nextFollowUp}
//                     onChange={handleFollowUpChange}
//                     style={{
//                       width: '100%',
//                       padding: '0.75rem',
//                       border: '1px solid #d1d5db',
//                       borderRadius: '0.5rem',
//                       fontSize: '1rem',
//                       outline: 'none',
//                       transition: 'border-color 0.2s ease'
//                     }}
//                   />
//                 </div>
//               </div>

//               <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '2rem' }}>
//                 <button
//                   type="button"
//                   onClick={() => setShowFollowUpForm(false)}
//                   style={{
//                     ...btnStyle,
//                     backgroundColor: '#6b7280',
//                     color: 'white',
//                     padding: '0.5rem 1rem'
//                   }}
//                   onMouseEnter={(e) => {
//                     e.target.style.transform = 'translateY(-2px)';
//                     e.target.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.transform = 'translateY(0px)';
//                     e.target.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
//                   }}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   style={{
//                     ...btnStyle,
//                     backgroundColor: '#3b82f6',
//                     color: 'white',
//                     padding: '0.5rem 1rem'
//                   }}
//                   onMouseEnter={(e) => {
//                     e.target.style.transform = 'translateY(-2px)';
//                     e.target.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.2)';
//                   }}
//                   onMouseLeave={(e) => {
//                     e.target.style.transform = 'translateY(0px)';
//                     e.target.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
//                   }}
//                 >
//                   <Calendar size={16} />
//                   Create Project-Task
//                 </button>
//               </div>
//             </form>
//           </div>
//         )}


//         {/* Existing Follow-Ups */}
//         {console.log('DEBUG: localMilestones state:', localMilestones, 'Length:', localMilestones.length) || localMilestones.length > 0 ? (
//           <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
//             {localMilestones.map((ms, index) => {
//               console.log(`Rendering milestone ${index}:`, ms);

//               // Calculate dynamic status based on due date and completion
//               const calculateDynamicStatus = (milestone) => {
//                 const currentDate = new Date();
//                 const dueDate = milestone.dueDate ? new Date(milestone.dueDate) : null;
//                 const status = milestone.status || 'Pending';

//                 // If manually set to completed, check if it was completed on time or late
//                 if (status === 'Completed') {
//                   if (dueDate && currentDate > dueDate) {
//                     return 'Late Completed';
//                   }
//                   return 'Completed';
//                 }

//                 // If not completed, check if overdue
//                 if (dueDate && currentDate > dueDate) {
//                   return 'Overdue';
//                 }

//                 // Default to pending for new tasks
//                 return 'Pending';
//               };

//               const dynamicStatus = calculateDynamicStatus(ms);
//               return (
//               <div 
//                 key={ms._id || ms.id || `milestone-${index}`} 
//                 style={{ 
//                   background: '#f8f9fa',
//                   borderRadius: '1rem',
//                   padding: '1.5rem',
//                   border: '1px solid #dee2e6',
//                   boxShadow: '0 5px 15px rgba(0, 0, 0, 0.05)',
//                   transition: 'all 0.3s ease'
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = 'translateY(-3px)';
//                   e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.1)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = 'translateY(0px)';
//                   e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.05)';
//                 }}
//               >
//                 <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
//                   <div style={{ flex: 1 }}>
//                     <h5 style={{
//                       margin: '0 0 0.5rem 0',
//                       fontSize: '1.1rem',
//                       fontWeight: 600,
//                       color: '#333',
//                     }}>
//                       {ms.title}
//                     </h5>
//                     {ms.description && (
//                       <p style={{
//                         margin: '0 0 0.5rem 0',
//                         fontSize: '0.9rem',
//                         color: '#555',
//                         fontStyle: 'italic'
//                       }}>
//                         {ms.description}
//                       </p>
//                     )}
//                     <p style={{
//                       margin: '0 0 0.5rem 0',
//                       fontSize: '0.9rem',
//                       color: '#6c757d',
//                     }}>
//                       … Due: {ms.dueDate ? fmtDate(ms.dueDate) : 'No date set'}
//                     </p>
//                     {ms.assignedTeamMember && (
//                       <div style={{
//                         margin: '0 0 0.5rem 0',
//                         fontSize: '0.85rem',
//                         color: '#6c757d',
//                       }}>
//                         Assigned: {(() => {
//                           // Handle multiple assigned team members
//                           if (Array.isArray(ms.assignedTeamMember)) {
//                             if (ms.assignedTeamMember.length === 0) return 'Unassigned';

//                             const assignedNames = ms.assignedTeamMember.map(memberId => {
//                               if (typeof memberId === 'object') {
//                                 return memberId.teamMemberName || memberId.name || 'Unknown';
//                               }
//                               const assignedEmployee = employees?.find(emp => emp._id === memberId);
//                               return assignedEmployee ? (assignedEmployee.teamMemberName || assignedEmployee.name || 'Unknown') : 'Unknown Employee';
//                             });

//                             return (
//                               <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem', marginTop: '0.25rem' }}>
//                                 {assignedNames.map((name, index) => (
//                                   <span key={index} style={{
//                                     backgroundColor: '#e0f2fe',
//                                     color: '#0277bd',
//                                     padding: '0.1rem 0.4rem',
//                                     borderRadius: '0.25rem',
//                                     fontSize: '0.8rem',
//                                     fontWeight: 500
//                                   }}>
//                                     {name}
//                                   </span>
//                                 ))}
//                               </div>
//                             );
//                           } else {
//                             // Handle single assigned team member (backward compatibility)
//                             if (typeof ms.assignedTeamMember === 'object') {
//                               return ms.assignedTeamMember.teamMemberName || ms.assignedTeamMember.name || 'Unknown';
//                             }
//                             const assignedEmployee = employees?.find(emp => emp._id === ms.assignedTeamMember);
//                             return assignedEmployee ? (assignedEmployee.teamMemberName || assignedEmployee.name || 'Unknown') : 'Unknown Employee';
//                           }
//                         })()}
//                       </div>
//                     )}
//                     {ms.nextFollowUp && (
//                       <p style={{
//                         margin: '0 0 0.5rem 0',
//                         fontSize: '0.85rem',
//                         color: '#6c757d',
//                       }}>
//                         „ Next Follow-up: {fmtDate(ms.nextFollowUp)}
//                       </p>
//                     )}
//                     <p style={{
//                       margin: '0',
//                       fontSize: '0.85rem',
//                       color: '#6c757d',
//                     }}>
//                        Project: {ms.projectName || project.title}
//                     </p>
//                   </div>
//                   <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
//                     <span style={getStatusBadgeStyle(dynamicStatus)}>
//                       {dynamicStatus === 'Pending' && ' '}
//                       {dynamicStatus === 'In Progress' && '„ '}
//                       {dynamicStatus === 'Completed' && '✅ '}
//                       {dynamicStatus === 'Late Completed' && ' '}
//                       {dynamicStatus === 'Overdue' && '⚠️ '}
//                       {dynamicStatus}
//                     </span>

//                     {/* Status Update Dropdown */}
//                     <div style={{ position: 'relative' }} data-dropdown-container>
//                       <button
//                         onClick={() => {
//                           const milestoneId = ms._id || ms.id;
//                           setOpenStatusDropdown(openStatusDropdown === milestoneId ? null : milestoneId);
//                         }}
//                         style={{
//                           color: 'white',
//                           background: 'rgba(59, 130, 246, 0.8)',
//                           border: '1px solid rgba(59, 130, 246, 0.9)',
//                           borderRadius: '0.375rem',
//                           cursor: 'pointer',
//                           padding: '0.375rem 0.5rem',
//                           transition: 'all 0.3s ease',
//                           fontSize: '0.75rem',
//                           fontWeight: 600,
//                           display: 'flex',
//                           alignItems: 'center',
//                           gap: '0.25rem'
//                         }}
//                         onMouseEnter={(e) => {
//                           e.target.style.background = 'rgba(59, 130, 246, 1)';
//                           e.target.style.transform = 'scale(1.05)';
//                         }}
//                         onMouseLeave={(e) => {
//                           e.target.style.background = 'rgba(59, 130, 246, 0.8)';
//                           e.target.style.transform = 'scale(1)';
//                         }}
//                         title="Update Status"
//                       >
//                         <span>Change Status</span>
//                         <span style={{ fontSize: '10px' }}>–</span>
//                       </button>

//                       {/* Dropdown Menu */}
//                       {openStatusDropdown === (ms._id || ms.id) && (
//                         <div style={{
//                           position: 'absolute',
//                           top: '100%',
//                           right: '0',
//                           backgroundColor: 'white',
//                           border: '1px solid #e5e7eb',
//                           borderRadius: '0.5rem',
//                           boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
//                           zIndex: 1000,
//                           minWidth: '150px',
//                           marginTop: '0.25rem'
//                         }}>
//                           {(statusOptions.length > 0 ? statusOptions : ['Pending', 'In Progress', 'Completed']).map((status, statusIndex) => (
//                             <button
//                               key={statusIndex}
//                               onClick={() => {
//                                 console.log('ProjectView - Changing status to:', status);
//                                 console.log('ProjectView - Milestone ID:', ms._id || ms.id);
//                                 handleStatusChange(ms._id || ms.id, status);
//                                 setOpenStatusDropdown(null);
//                               }}
//                               style={{
//                                 width: '100%',
//                                 padding: '0.5rem 0.75rem',
//                                 textAlign: 'left',
//                                 border: 'none',
//                                 backgroundColor: ms.status === status ? '#f3f4f6' : 'transparent',
//                                 color: ms.status === status ? '#1f2937' : '#6b7280',
//                                 fontSize: '0.875rem',
//                                 cursor: 'pointer',
//                                 borderRadius: statusIndex === 0 ? '0.5rem 0.5rem 0 0' : 
//                                            statusIndex === (statusOptions.length > 0 ? statusOptions.length - 1 : 2) ? '0 0 0.5rem 0.5rem' : '0',
//                                 transition: 'all 0.2s ease'
//                               }}
//                               onMouseEnter={(e) => {
//                                 if (ms.status !== status) {
//                                   e.target.style.backgroundColor = '#f9fafb';
//                                   e.target.style.color = '#1f2937';
//                                 }
//                               }}
//                               onMouseLeave={(e) => {
//                                 if (ms.status !== status) {
//                                   e.target.style.backgroundColor = 'transparent';
//                                   e.target.style.color = '#6b7280';
//                                 }
//                               }}
//                             >
//                               {status}
//                               {ms.status === status && (
//                                 <span style={{ float: 'right', color: '#10b981' }}>✅</span>
//                               )}
//                             </button>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                     {/* <button
//                       onClick={() => handleDelete(ms._id || ms.id)}
//                       style={{
//                         color: 'white',
//                         background: 'rgba(239, 68, 68, 0.2)',
//                         border: '1px solid rgba(239, 68, 68, 0.3)',
//                         borderRadius: '0.25rem',
//                         cursor: 'pointer',
//                         padding: '0.25rem',
//                         transition: 'all 0.3s ease'
//                       }}
//                       onMouseEnter={(e) => {
//                         e.target.style.background = 'rgba(239, 68, 68, 0.4)';
//                       }}
//                       onMouseLeave={(e) => {
//                         e.target.style.background = 'rgba(239, 68, 68, 0.2)';
//                       }}
//                       title="Delete Milestone"
//                     >
//                       <Trash2 size={16} />
//                     </button> */}
//                   </div>
//                 </div>
//               </div>
//               );
//             })}
//           </div>
//         ) : (
//           !showFollowUpForm && <div style={emptyStateStyle}>No Project-Tasks created for this project.</div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProjectView;









import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import AlertBox from '../../Components/AlertBox';
import {
  ArrowLeft,
  Calendar,
  IndianRupee,
  Target,
  Clock,
  Users,
  Mail,
  Phone,
  BarChart3,
  Building2,
  Plus,
  X,
  Sparkles,
  Download,
  ChevronRight,
  FileText,
  User,
  MapPin,
  PhoneCall,
  Briefcase,
  CheckCircle2,
  AlertCircle,
  PlayCircle,
  PauseCircle,
  RefreshCw,
  MoreVertical
} from 'lucide-react';

const ProjectView = ({ projects = [], employees: employeesProp = [], milestones = [], setMilestones, onNavigate, projectId }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  console.log("projectId prop received:", projectId);
  console.log("projects array length:", projects?.length);

  useEffect(() => {
    setTimeout(() => setIsLoaded(true), 100);
  }, []);

  // ---------- hooks ----------
  const { id } = useParams();
  const navigate = useNavigate();

  // Get project ID from props first, then useParams, then URL
  const getCurrentProjectId = () => {
    if (projectId) {
      console.log('✅ Using projectId from props:', projectId);
      return projectId;
    }
    if (id) {
      console.log('✅ Using id from useParams:', id);
      return id;
    }

    const currentPath = window.location.pathname;
    if (currentPath.startsWith('/projects/')) {
      const extractedId = currentPath.split('/projects/')[1];
      console.log('✅ Using id from URL path:', extractedId);
      return extractedId;
    }
    return null;
  };

  const currentProjectId = getCurrentProjectId();

  // Debug logging
  console.log('ProjectView Debug:', {
    projectIdProp: projectId,
    useParamsId: currentProjectId,
    currentProjectId: currentProjectId,
    projectsCount: projects.length,
    foundProject: projects.find(p => String(p._id || p.id) === String(currentProjectId))
  });

  // Try to fetch employees if not provided (fallback)
  const [employees, setEmployees] = useState(employeesProp);
  const [department, setDepartment] = useState([]);
  const [showFollowUpForm, setShowFollowUpForm] = useState(false);
  const [localMilestones, setLocalMilestones] = useState(Array.isArray(milestones) ? milestones : []);
  const [showAlert, setShowAlert] = useState(null);
  const [followUpFormData, setFollowUpFormData] = useState({
    title: '',
    projectName: '',
    description: '',
    dueDate: '',
    status: '',
    assignedTeamMember: [],
    nextFollowUp: ''
  });
  const [hoveredExport, setHoveredExport] = useState(false);
  const [employeeDetails, setEmployeeDetails] = useState({});
  const [statusOptions, setStatusOptions] = useState(['Pending', 'In Progress', 'Completed', 'Overdue']);
  const [openStatusDropdown, setOpenStatusDropdown] = useState(null);
  const [openTeamMemberDropdown, setOpenTeamMemberDropdown] = useState(false);
  const [projectData, setProjectData] = useState(null);
  const [projectLoading, setProjectLoading] = useState(false);

  // First try to find in passed projects array
  const projectFromArray = useMemo(
    () => projects.find(p => String(p._id || p.id) === String(currentProjectId)),
    [projects, currentProjectId]
  );

  // Fetch project from API if not found in array
  useEffect(() => {
    if (!projectFromArray && currentProjectId) {
      setProjectLoading(true);
      const fetchProject = async () => {
        try {
          const token = localStorage.getItem('authToken');
          if (!token) {
            console.error('No auth token found');
            setProjectLoading(false);
            return;
          }

          const response = await fetch(`https://crm-tkxn.onrender.com/api/projectsmgnt/${currentProjectId}`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          if (response.ok) {
            const data = await response.json();
            console.log('✅ Fetched project from API:', data);
            setProjectData(data);
          } else {
            console.error('Failed to fetch project:', response.status);
          }
        } catch (error) {
          console.error('Error fetching project:', error);
        } finally {
          setProjectLoading(false);
        }
      };

      fetchProject();
    } else if (projectFromArray) {
      setProjectData(projectFromArray);
      setProjectLoading(false);
    }
  }, [currentProjectId, projectFromArray]);

  const project = projectData;

  // Function to fetch individual employee details
  const fetchEmployeeDetails = useCallback(async (employeeId) => {
    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        console.error('No access token found');
        return null;
      }

      console.log('Fetching employee details for ID:', employeeId);

      const response = await fetch(`https://crm-tkxn.onrender.com/api/employees/${employeeId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (response.ok) {
        const employeeData = await response.json();
        console.log('✅ Employee details fetched:', employeeData);

        setEmployeeDetails(prev => ({
          ...prev,
          [employeeId]: employeeData
        }));

        return employeeData;
      } else {
        console.error('❌ Failed to fetch employee details:', response.status);
        return null;
      }
    } catch (error) {
      console.error('❌ Error fetching employee details:', error);
      return null;
    }
  }, []);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (openStatusDropdown && !event.target.closest('[data-dropdown-container]')) {
        setOpenStatusDropdown(null);
      }
      if (openTeamMemberDropdown && !event.target.closest('[data-team-dropdown-container]')) {
        setOpenTeamMemberDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openStatusDropdown, openTeamMemberDropdown]);

  // Update form default status when statusOptions change
  useEffect(() => {
    console.log('ProjectView - statusOptions updated:', statusOptions);
    if (showFollowUpForm && !followUpFormData.status && statusOptions.length > 0) {
      console.log('ProjectView - Auto-setting status to:', statusOptions[0]);
      setFollowUpFormData(prev => ({
        ...prev,
        status: statusOptions[0]
      }));
    }
  }, [statusOptions, showFollowUpForm, followUpFormData.status]);

  // Fetch employees and departments
  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const token = localStorage.getItem('authToken');
        let COMPANY_ID = '';
        if (token) {
          try {
            const decodedToken = jwtDecode(token);
            COMPANY_ID = decodedToken.role === 'company'
              ? (decodedToken.companyId || decodedToken.id)
              : decodedToken.companyId;
          } catch (err) {
            console.error("Error decoding token:", err);
          }
        }

        const res = await fetch(`https://crm-tkxn.onrender.com/api/employees/company/${COMPANY_ID}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (res.ok) {
          const data = await res.json();
          setEmployees(data || []);
        } else {
          console.error('Failed to fetch employees - Status:', res.status);
          const fallbackRes = await fetch('https://crm-tkxn.onrender.com/api/employees', {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          });
          if (fallbackRes.ok) {
            const fallbackData = await fallbackRes.json();
            setEmployees(fallbackData || []);
          } else {
            setEmployees([]);
          }
        }
      } catch (error) {
        console.error('Error fetching employees:', error);
        setEmployees([]);
      }
    };

    const fetchDepartments = async () => {
      try {
        const token = localStorage.getItem('authToken');
        let COMPANY_ID = '';
        if (token) {
          try {
            const decodedToken = jwtDecode(token);
            COMPANY_ID = decodedToken.role === 'company'
              ? (decodedToken.companyId || decodedToken.id)
              : decodedToken.companyId;
          } catch (err) {
            console.error("Error decoding token:", err);
          }
        }

        const response = await fetch(`https://crm-tkxn.onrender.com/api/departments/company/${COMPANY_ID}`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          setDepartment(Array.isArray(data) ? data : []);
        } else {
          console.error('Failed to fetch departments:', response.status);
          setDepartment([]);
        }
      } catch (error) {
        console.error('Error fetching departments:', error);
        setDepartment([]);
      }
    };

    fetchEmployees();
    fetchDepartments();
  }, []);

  // Fetch detailed employee data
  useEffect(() => {
    const fetchEmployeeDetailsForProject = async () => {
      if (!project) return;

      const employeeIdsToFetch = [];

      // Add project head ID if exists
      if (project.projectHead) {
        const projectHeadId = typeof project.projectHead === 'string' ? project.projectHead : project.projectHead._id;
        if (projectHeadId) {
          employeeIdsToFetch.push(projectHeadId);
        }
      }

      // Add team member IDs
      if (project.teamMembers && project.teamMembers.length > 0) {
        const memberIds = project.teamMembers.map(member => {
          if (typeof member === 'string') return member;
          if (typeof member === 'object' && member._id) return member._id;
          return null;
        }).filter(Boolean);
        employeeIdsToFetch.push(...memberIds);
      }

      // Add milestone assigned team member IDs
      if (localMilestones && localMilestones.length > 0) {
        localMilestones.forEach(milestone => {
          if (milestone.assignedTeamMember) {
            if (Array.isArray(milestone.assignedTeamMember)) {
              milestone.assignedTeamMember.forEach(member => {
                if (typeof member === 'string') {
                  employeeIdsToFetch.push(member);
                } else if (typeof member === 'object' && member !== null && (member._id || member.id)) {
                  employeeIdsToFetch.push(member._id || member.id);
                }
              });
            } else if (typeof milestone.assignedTeamMember === 'string') {
              employeeIdsToFetch.push(milestone.assignedTeamMember);
            } else if (typeof milestone.assignedTeamMember === 'object' && milestone.assignedTeamMember !== null) {
              const objectId = milestone.assignedTeamMember._id || milestone.assignedTeamMember.id;
              if (objectId) employeeIdsToFetch.push(objectId);
            }
          }
        });
      }

      const uniqueEmployeeIds = [...new Set(employeeIdsToFetch)];
      for (const employeeId of uniqueEmployeeIds) {
        if (!employeeDetails[employeeId]) {
          await fetchEmployeeDetails(employeeId);
        }
      }
    };

    if (project) {
      fetchEmployeeDetailsForProject();
    }
  }, [project, localMilestones, employeeDetails, fetchEmployeeDetails]);

  // Fetch milestones
  useEffect(() => {
    const fetchMilestones = async () => {
      const authToken = localStorage.getItem('authToken');
      if (!authToken || !currentProjectId) return;

      try {
        const res = await fetch('https://crm-tkxn.onrender.com/api/milestones', {
          headers: { 'Authorization': `Bearer ${authToken}` }
        });

        if (res.ok) {
          const response = await res.json();
          const data = response.milestones || response;
          const projectIdForMilestones = project?._id || currentProjectId;
          const currentProjectName = project?.title || project?.name;

          let projectMilestones = Array.isArray(data) ? data.filter(m => {
            const milestoneProjectId = m.project || m.projectId;
            const matchesId = String(milestoneProjectId) === String(projectIdForMilestones);
            const matchesName = m.projectName === currentProjectName;
            const matchesProjectRef = m.project && typeof m.project === 'object' && String(m.project._id) === String(projectIdForMilestones);
            return matchesId || matchesName || matchesProjectRef;
          }) : [];

          // Filter milestones based on user role
          let decodedToken;
          try {
            decodedToken = jwtDecode(authToken);
          } catch (e) {
            console.error('ProjectView - Error decoding token:', e);
          }

          if (decodedToken) {
            const userRole = decodedToken.role;
            const userId = decodedToken.id || decodedToken._id;
            const normalizedRole = userRole ? userRole.toLowerCase() : '';

            if (normalizedRole === 'employee' || normalizedRole === 'team_member') {
              projectMilestones = projectMilestones.filter(milestone => {
                const assignedTeamMember = milestone.assignedTeamMember;
                if (!assignedTeamMember) return false;

                if (Array.isArray(assignedTeamMember)) {
                  return assignedTeamMember.some(member => {
                    const memberId = typeof member === 'object' ? (member._id || member.id) : member;
                    return String(memberId) === String(userId);
                  });
                }

                const memberId = typeof assignedTeamMember === 'object' ?
                  (assignedTeamMember._id || assignedTeamMember.id) : assignedTeamMember;
                return String(memberId) === String(userId);
              });
            }
          }

          setLocalMilestones(projectMilestones);

          if (setMilestones && typeof setMilestones === 'function') {
            setMilestones(prev => {
              const otherProjectMilestones = prev.filter(m => m.projectName !== currentProjectName);
              return [...otherProjectMilestones, ...projectMilestones];
            });
          }
        } else {
          console.error('Failed to fetch milestones:', res.status, res.statusText);
          setLocalMilestones([]);
        }
      } catch (e) {
        console.error('Error in milestone fetch:', e);
        setLocalMilestones([]);
      }
    };

    fetchMilestones();
  }, [currentProjectId, project, setMilestones]);

  // Force milestone fetch on component mount
  useEffect(() => {
    const forceFetchMilestones = async () => {
      const authToken = localStorage.getItem('authToken');
      if (!authToken || !currentProjectId) return;

      try {
        const res = await fetch('https://crm-tkxn.onrender.com/api/milestones', {
          headers: { 'Authorization': `Bearer ${authToken}` }
        });

        if (res.ok) {
          const response = await res.json();
          const allMilestones = response.milestones || response;
          let projectMilestones = Array.isArray(allMilestones) ?
            allMilestones.filter(m => {
              const milestoneProjectId = m.project || m.projectId;
              const matchesId = String(milestoneProjectId) === String(currentProjectId);
              const matchesProjectRef = m.project && typeof m.project === 'object' && String(m.project._id) === String(currentProjectId);
              return matchesId || matchesProjectRef;
            }) : [];

          // Filter milestones based on user role
          let decodedToken;
          try {
            decodedToken = jwtDecode(authToken);
          } catch (e) {
            console.error('ProjectView - Error decoding token:', e);
          }

          if (decodedToken) {
            const userRole = decodedToken.role;
            const userId = decodedToken.id || decodedToken._id;
            const normalizedRole = userRole ? userRole.toLowerCase() : '';

            if (normalizedRole === 'employee' || normalizedRole === 'team_member') {
              projectMilestones = projectMilestones.filter(milestone => {
                const assignedTeamMember = milestone.assignedTeamMember;
                if (!assignedTeamMember) return false;

                if (Array.isArray(assignedTeamMember)) {
                  return assignedTeamMember.some(member => {
                    const memberId = typeof member === 'object' ? (member._id || member.id) : member;
                    return String(memberId) === String(userId);
                  });
                }

                const memberId = typeof assignedTeamMember === 'object' ?
                  (assignedTeamMember._id || assignedTeamMember.id) : assignedTeamMember;
                return String(memberId) === String(userId);
              });
            }
          }

          setLocalMilestones(projectMilestones);
        }
      } catch (error) {
        console.error('Force fetch milestones error:', error);
      }
    };

    forceFetchMilestones();
  }, [currentProjectId]);

  // Refresh milestones function
  const refreshMilestones = useCallback(async () => {
    console.log('„ Manual milestone refresh triggered');
    const authToken = localStorage.getItem('authToken');
    if (!authToken || !currentProjectId) return;

    try {
      const res = await fetch('https://crm-tkxn.onrender.com/api/milestones', {
        headers: { 'Authorization': `Bearer ${authToken}` }
      });

      if (res.ok) {
        const response = await res.json();
        const data = response.milestones || response;
        const projectIdForMilestones = project?._id || currentProjectId;
        const currentProjectName = project?.title || project?.name;

        let projectMilestones = Array.isArray(data) ? data.filter(m => {
          const milestoneProjectId = m.project || m.projectId;
          const matchesId = String(milestoneProjectId) === String(projectIdForMilestones);
          const matchesName = m.projectName === currentProjectName;
          const matchesProjectRef = m.project && typeof m.project === 'object' && String(m.project._id) === String(projectIdForMilestones);
          return matchesId || matchesName || matchesProjectRef;
        }) : [];

        // Filter milestones based on user role
        let decodedToken;
        try {
          decodedToken = jwtDecode(authToken);
        } catch (e) {
          console.error('ProjectView - Error decoding token:', e);
        }

        if (decodedToken) {
          const userRole = decodedToken.role;
          const userId = decodedToken.id || decodedToken._id;
          const normalizedRole = userRole ? userRole.toLowerCase() : '';

          if (normalizedRole === 'employee' || normalizedRole === 'team_member') {
            projectMilestones = projectMilestones.filter(milestone => {
              const assignedTeamMember = milestone.assignedTeamMember;
              if (!assignedTeamMember) return false;

              if (Array.isArray(assignedTeamMember)) {
                return assignedTeamMember.some(member => {
                  const memberId = typeof member === 'object' ? (member._id || member.id) : member;
                  return String(memberId) === String(userId);
                });
              }

              const memberId = typeof assignedTeamMember === 'object' ?
                (assignedTeamMember._id || assignedTeamMember.id) : assignedTeamMember;
              return String(memberId) === String(userId);
            });
          }
        }

        setLocalMilestones(projectMilestones);
      }
    } catch (error) {
      console.error('❌ Error refreshing milestones:', error);
    }
  }, [currentProjectId, project]);

  // Helpers
  const toDate = (d) => (d ? new Date(d) : null);
  const fmtDate = (d) => {
    if (!d) return 'N/A';
    const date = new Date(d);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };
  const num = (v) => {
    const n = typeof v === 'string' ? parseFloat(v) : v;
    return Number.isFinite(n) ? n : 0;
  };

  // Calculate progress based on status position
  const getStatusProgress = (currentStatus, statusOptions) => {
    if (!statusOptions || statusOptions.length === 0) {
      const defaultStatuses = ['Planning', 'In Progress', 'Completed'];
      const statusIndex = defaultStatuses.findIndex(status =>
        status.toLowerCase() === (currentStatus || '').toLowerCase()
      );
      const currentPosition = statusIndex >= 0 ? statusIndex + 1 : 1;
      return {
        current: currentPosition,
        total: defaultStatuses.length,
        percentage: Math.round((currentPosition / defaultStatuses.length) * 100)
      };
    }

    const statusIndex = statusOptions.findIndex(status =>
      status.toLowerCase() === (currentStatus || '').toLowerCase()
    );
    const currentPosition = statusIndex >= 0 ? statusIndex + 1 : 1;

    return {
      current: currentPosition,
      total: statusOptions.length,
      percentage: Math.round((currentPosition / statusOptions.length) * 100)
    };
  };

  // Team members normalization
  const teamMembers = useMemo(() => {
    // Build a normalized map from project.teamMembers (may be IDs or objects)
    const projectList = Array.isArray(project?.teamMembers) ? project.teamMembers : [];

    const normalize = (src) => {
      if (!src) return null;

      let id = 'unknown';
      let detailed = null;

      // If it's an object with name fields
      if (typeof src === 'object' && (src.name || src.teamMemberName || src._id)) {
        id = src._id || src.id || 'unknown';
        detailed = employeeDetails[id] || (employees || []).find(e => String(e._id) === String(id)) || src;
      }
      // If it's a string ID
      else if (typeof src === 'string') {
        id = src;
        detailed = employeeDetails[id] || (employees || []).find(e => String(e._id) === String(id));
      }

      if (detailed) {
        // Check active status
        if (detailed.isActive === false) return null;

        const position = detailed.role || detailed.position || detailed.designation || detailed.jobTitle || 'Position not available';
        const name = detailed.teamMemberName || detailed.name || detailed.firstName || 'No Name';
        const email = detailed.email || detailed.emailAddress || '';

        return {
          _id: detailed._id || id,
          name,
          teamMemberName: name,
          email,
          role: position
        };
      }

      return null;
    };

    return projectList.map(normalize).filter(Boolean);
  }, [project, employees, employeeDetails]);

  // Form handlers
  const handleFollowUpChange = (e) => {
    setFollowUpFormData({
      ...followUpFormData,
      [e.target.name]: e.target.value
    });
  };

  const handleFollowUpSubmit = async (e) => {
    e.preventDefault();

    if (!followUpFormData.title || !followUpFormData.dueDate) {
      setShowAlert('Please fill in all required fields (Title and Due Date)');
      return;
    }

    const authToken = localStorage.getItem('authToken');
    let companyId = '';

    if (authToken) {
      try {
        const decodedToken = jwtDecode(authToken);
        companyId = decodedToken.role === 'company'
          ? (decodedToken.companyId || decodedToken.id)
          : decodedToken.companyId;
      } catch (err) {
        console.error("Error decoding token:", err);
      }
    }

    const newMilestone = {
      title: followUpFormData.title,
      project: project._id,
      projectName: project.title || project.name,
      description: followUpFormData.description,
      dueDate: followUpFormData.dueDate,
      status: followUpFormData.status || 'Pending',
      assignedTeamMember: followUpFormData.assignedTeamMember.length > 0 ? followUpFormData.assignedTeamMember : undefined,
      nextFollowUp: followUpFormData.nextFollowUp || undefined,
      company: companyId
    };

    try {
      const res = await fetch('https://crm-tkxn.onrender.com/api/milestones', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify(newMilestone)
      });

      if (res.ok) {
        const created = await res.json();
        const actualMilestone = created.milestone || created;

        const tempMilestone = {
          ...actualMilestone,
          _id: actualMilestone._id || Date.now().toString(),
          project: project._id,
          projectId: project._id,
          projectName: project.title || project.name,
          title: actualMilestone.title || followUpFormData.title,
          status: actualMilestone.status || followUpFormData.status || 'Pending',
          dueDate: actualMilestone.dueDate || followUpFormData.dueDate,
          description: actualMilestone.description || followUpFormData.description,
          assignedTeamMember: actualMilestone.assignedTeamMember || followUpFormData.assignedTeamMember,
          nextFollowUp: actualMilestone.nextFollowUp || followUpFormData.nextFollowUp
        };

        setLocalMilestones(prev => [...prev, tempMilestone]);

        setFollowUpFormData({
          title: '',
          projectName: '',
          description: '',
          dueDate: '',
          status: 'Pending',
          assignedTeamMember: [],
          nextFollowUp: ''
        });
        setShowFollowUpForm(false);

        setTimeout(async () => {
          try {
            const fetchRes = await fetch('https://crm-tkxn.onrender.com/api/milestones', {
              headers: { 'Authorization': `Bearer ${authToken}` }
            });
            if (fetchRes.ok) {
              const response = await fetchRes.json();
              const allMilestones = response.milestones || response;
              const currentProjectId = project._id;
              const currentProjectName = project.title || project.name;

              const projectMilestones = Array.isArray(allMilestones) ?
                allMilestones.filter(m => {
                  const milestoneProjectId = m.project || m.projectId;
                  const matchesId = String(milestoneProjectId) === String(currentProjectId);
                  const matchesName = m.projectName === currentProjectName;
                  const matchesProjectRef = m.project && typeof m.project === 'object' && String(m.project._id) === String(currentProjectId);
                  return matchesId || matchesName || matchesProjectRef;
                }) : [];
              setLocalMilestones(projectMilestones);
            }
          } catch (error) {
            console.error('Error refetching after creation:', error);
          }
        }, 500);
      } else {
        console.error('Failed to create milestone:', res.status, res.statusText);
        try {
          const errorData = await res.json();
          console.error('Error details:', errorData);
          setShowAlert(`Failed to create task: ${errorData.message || res.statusText}`);
        } catch (e) {
          try {
            const errorText = await res.text();
            setShowAlert(`Failed to create task: ${res.status} ${res.statusText}\n${errorText}`);
          } catch (e2) {
            setShowAlert(`Failed to create task: ${res.status} ${res.statusText}`);
          }
        }
      }
    } catch (error) {
      console.error('Error creating milestone:', error);
    }
  };

  // Milestone management functions
  const handleStatusChange = async (milestoneId, newStatus) => {
    if (!milestoneId) {
      console.error('Milestone ID is undefined, cannot update status');
      return;
    }

    try {
      const authToken = localStorage.getItem('authToken');
      const res = await fetch(`https://crm-tkxn.onrender.com/api/milestones/${milestoneId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({ status: newStatus })
      });

      if (res.ok) {
        const updated = await res.json();
        setLocalMilestones(prev =>
          prev.map(m => ((m._id || m.id) === milestoneId ? { ...m, status: newStatus } : m))
        );

        // Show success popup message
        setShowAlert(`✅ Milestone status updated to "${newStatus}" successfully!`);

        console.log(`Milestone status updated to: ${newStatus}`);
      } else {
        console.error('Failed to update milestone:', res.status);
        setShowAlert('Failed to update milestone status. Please try again.');
      }
    } catch (error) {
      console.error('Failed to update milestone:', error);
      setShowAlert('Error updating milestone status. Please try again.');
    }
  };

  // PDF Export Function
  const exportToPDF = async () => {
    const doc = new jsPDF();
    const currentDate = fmtDate(new Date());

    // Add title
    doc.setFontSize(18);
    doc.setTextColor(31, 41, 55);
    doc.text(`Project: ${project.title || project.name}`, 14, 20);

    // Add date
    doc.setFontSize(10);
    doc.setTextColor(107, 114, 128);
    doc.text(`Generated: ${currentDate}`, 14, 28);

    // Project Overview Table
    doc.setFontSize(14);
    doc.setTextColor(31, 41, 55);
    doc.text('Project Details', 14, 40);

    const projectOverviewData = [
      ['Project Name', project.title || project.name || 'N/A'],
      ['Description', project.description || 'N/A'],
      ['Status', project.status || 'N/A'],
      ['Start Date', fmtDate(start)],
      ['Due Date', fmtDate(due)],
      ['Budget', `₹${budget.toLocaleString('en-IN')}`],
      ['Progress', `${progress}%`]
    ];

    autoTable(doc, {
      startY: 45,
      head: [['Field', 'Value']],
      body: projectOverviewData,
      theme: 'striped',
      headStyles: {
        fillColor: [59, 130, 246],
        textColor: [255, 255, 255],
        fontStyle: 'bold'
      }
    });

    let currentY = doc.lastAutoTable.finalY + 10;

    // Team Members Table
    if (teamMembers.length > 0) {
      doc.setFontSize(14);
      doc.text('Team Members', 14, currentY);

      const teamData = teamMembers.map((member) => [
        member.teamMemberName || member.name || 'N/A',
        member.email || 'N/A',
        member.role || 'Position not available'
      ]);

      autoTable(doc, {
        startY: currentY + 5,
        head: [['Name', 'Email', 'Position']],
        body: teamData,
        theme: 'striped',
        headStyles: {
          fillColor: [139, 92, 246],
          textColor: [255, 255, 255],
          fontStyle: 'bold'
        }
      });

      currentY = doc.lastAutoTable.finalY + 10;
    }

    // Client Information
    if (project.clientName || project.clientCompany) {
      doc.setFontSize(14);
      doc.text('Client Information', 14, currentY);

      const clientData = [];
      if (project.clientName) clientData.push(['Client Name', project.clientName]);
      if (project.clientCompany) clientData.push(['Company', project.clientCompany]);
      if (project.clientEmail) clientData.push(['Email', project.clientEmail]);
      if (project.clientMobileNo) clientData.push(['Mobile', project.clientMobileNo]);
      if (project.clientAddress) clientData.push(['Address', project.clientAddress]);
      if (project.clientCity) clientData.push(['City', project.clientCity]);
      if (project.clientState) clientData.push(['State', project.clientState]);

      autoTable(doc, {
        startY: currentY + 5,
        head: [['Field', 'Value']],
        body: clientData,
        theme: 'striped',
        headStyles: {
          fillColor: [16, 185, 129],
          textColor: [255, 255, 255],
          fontStyle: 'bold'
        }
      });

      currentY = doc.lastAutoTable.finalY + 10;
    }

    // Project Tasks
    if (localMilestones.length > 0) {
      if (currentY > 250) {
        doc.addPage();
        currentY = 20;
      }

      doc.setFontSize(14);
      doc.text('Project Tasks', 14, currentY);

      const taskData = localMilestones.map((task) => [
        task.title || 'N/A',
        task.description || 'No description',
        task.status || 'Pending',
        task.dueDate ? fmtDate(task.dueDate) : 'Not set'
      ]);

      autoTable(doc, {
        startY: currentY + 5,
        head: [['Task Title', 'Description', 'Status', 'Due Date']],
        body: taskData,
        theme: 'striped',
        headStyles: {
          fillColor: [245, 158, 11],
          textColor: [255, 255, 255],
          fontStyle: 'bold'
        }
      });
    }

    // Save the PDF
    const projectName = (project.title || project.name || 'Project').replace(/[^a-zA-Z0-9]/g, '-');
    doc.save(`${projectName}-Details-${currentDate.replace(/\//g, '-')}.pdf`);
  };

  // Status badge styling function
  const getStatusBadgeStyle = (status) => {
    const baseClasses = "px-3 py-1 rounded-full text-xs font-semibold border";

    switch (status) {
      case 'Completed':
        return `${baseClasses} bg-gradient-to-r from-green-100 to-emerald-100 text-green-800 border-green-200 shadow-sm`;
      case 'Late Completed':
        return `${baseClasses} bg-gradient-to-r from-amber-100 to-orange-100 text-amber-800 border-amber-200 shadow-sm`;
      case 'Overdue':
        return `${baseClasses} bg-gradient-to-r from-red-100 to-pink-100 text-red-800 border-red-200 shadow-sm`;
      case 'In Progress':
        return `${baseClasses} bg-gradient-to-r from-blue-100 to-cyan-100 text-blue-800 border-blue-200 shadow-sm`;
      case 'Pending':
        return `${baseClasses} bg-gradient-to-r from-purple-100 to-indigo-100 text-purple-800 border-purple-200 shadow-sm`;
      default:
        return `${baseClasses} bg-gradient-to-r from-gray-100 to-slate-100 text-gray-800 border-gray-200 shadow-sm`;
    }
  };

  // Progress calculation
  const progressData = project ? getStatusProgress(project.status, statusOptions) : { percentage: 0 };
  const progress = progressData.percentage;
  const budget = project ? num(project.budget) : 0;
  const start = project ? toDate(project.startDate) : null;
  const due = project ? toDate(project.dueDate) : null;

  if (!project) {
    if (projectLoading) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-4 text-gray-600">Loading project details...</p>
          </div>
        </div>
      );
    }

    return (
      <div className="min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-gray-200/50 p-6">
            <div className="flex items-center space-x-4 mb-6">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (onNavigate) {
                    onNavigate('/projects', 'Projects');
                  } else if (navigate) {
                    navigate('/projects');
                  }
                }}
                className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200 bg-white/50 backdrop-blur-sm px-4 py-2 rounded-xl border border-gray-200/50 hover:border-gray-300/50"
              >
                <ArrowLeft className="w-5 h-5" />
                <span>Back to Projects</span>
              </button>
            </div>
            <div className="text-center py-12">
              <div className="w-20 h-20 bg-gradient-to-r from-red-100 to-pink-100 rounded-full flex items-center justify-center mx-auto mb-4 border border-red-200/50">
                <AlertCircle className="w-10 h-10 text-red-500" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">Project Not Found</h2>
              <p className="text-gray-600">The requested project could not be found.</p>
              <div className="mt-4 text-sm text-gray-500">
                Debug info - Current Project ID: {currentProjectId} | Projects in array: {projects.length}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
        <div className="bg-white/95 backdrop-blur-lg border border-gray-200/50 shadow-md rounded-2xl sticky top-4 z-10 p-6 mb-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (onNavigate) {
                    onNavigate('/projects', 'Projects');
                  } else if (navigate) {
                    navigate('/projects');
                  }
                }}
                className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200 p-2 rounded-xl hover:bg-white/50 backdrop-blur-sm border border hover:border-gray-200/50"
              >
                <ArrowLeft className="w-5 h-5" />
                <span className="font-medium">Back to Projects</span>
              </button>
              <div className="h-6 w-px bg-gradient-to-b from-gray-300 to-gray-200"></div>
              <div className="flex-1 min-w-0">
                <h1 className="text-2xl font-bold text-gray-900 flex items-center space-x-3">
                  <div className="p-2 bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl shadow-lg flex-shrink-0">
                    <Sparkles className="w-6 h-6 text-white" />
                  </div>
                  <span className="truncate">{project.title || project.name || 'Untitled Project'}</span>
                </h1>
                <p className="text-gray-600 mt-1 truncate">Project details and management</p>
              </div>
            </div>
            <button
              onClick={exportToPDF}
              className="flex items-center space-x-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white px-4 py-2 rounded-xl transition-all duration-200 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
            >
              <Download className="w-4 h-4" />
              <span>Export PDF</span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Left Column - Project Details */}
          <div className="lg:col-span-2 space-y-8">
            {/* Project Tasks */}
            <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-gray-200/50 p-6 hover:shadow-2xl transition-all duration-300">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-gray-900 flex items-center space-x-2">
                  <div className="p-2 bg-gradient-to-r from-pink-100 to-pink-200 rounded-lg">
                    <Target className="w-5 h-5 text-pink-600" />
                  </div>
                  <span>Project Tasks</span>
                </h3>
                <div className="flex items-center space-x-3">
                  <button
                    onClick={refreshMilestones}
                    className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200 p-2 rounded-xl hover:bg-white/50 backdrop-blur-sm border border-transparent hover:border-gray-200/50"
                    title="Refresh Tasks"
                  >
                    <RefreshCw className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => {
                      if (!showFollowUpForm) {
                        let defaultStatus = 'Pending';
                        if (statusOptions.length > 0) {
                          const preferredDefaults = ['Planning', 'To Do', 'Pending', 'Not Started'];
                          const foundDefault = preferredDefaults.find(status =>
                            statusOptions.some(option => option.toLowerCase() === status.toLowerCase())
                          );
                          defaultStatus = foundDefault || statusOptions[0];
                        }
                        setFollowUpFormData({
                          title: '',
                          projectName: project.title || project.name || '',
                          description: '',
                          dueDate: '',
                          status: defaultStatus,
                          assignedTeamMember: [],
                          nextFollowUp: ''
                        });
                      }
                      setShowFollowUpForm(!showFollowUpForm);
                    }}
                    className="flex items-center space-x-2 bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white px-4 py-2 rounded-xl transition-all duration-200 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                  >
                    {showFollowUpForm ? (
                      <>
                        <X className="w-4 h-4" />
                        <span>Cancel</span>
                      </>
                    ) : (
                      <>
                        <Plus className="w-4 h-4" />
                        <span>Add Task</span>
                      </>
                    )}
                  </button>
                </div>
              </div>

              {/* Task Form */}
              {showFollowUpForm && (
                <div className="bg-gradient-to-r from-pink-50/60 to-rose-50/60 rounded-2xl p-6 border border-pink-200/50 mb-6 backdrop-blur-sm shadow-lg">
                  <form onSubmit={handleFollowUpSubmit} className="space-y-4">
                    <div>
                      <label htmlFor="title" className="block text-sm font-medium text-gray-700 mb-1">
                        Task Title *
                      </label>
                      <input
                        type="text"
                        id="title"
                        name="title"
                        value={followUpFormData.title}
                        onChange={handleFollowUpChange}
                        placeholder="Enter task title"
                        required
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition-colors duration-200 bg-white/50 backdrop-blur-sm"
                      />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div className="md:col-span-2">
                        <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-2">
                          Description
                        </label>
                        <textarea
                          id="description"
                          name="description"
                          value={followUpFormData.description}
                          onChange={handleFollowUpChange}
                          placeholder="Enter task description"
                          rows="6"
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition-colors duration-200 resize-vertical bg-white/60 backdrop-blur-sm shadow-sm"
                        />
                      </div>

                      <div className="md:col-span-1 space-y-4">
                        <label className="block text-sm font-medium text-gray-700 mb-1">Assigned Team Members</label>
                        <div className="relative" data-team-dropdown-container>
                          <div
                            onClick={() => setOpenTeamMemberDropdown(!openTeamMemberDropdown)}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg cursor-pointer bg-white/60 backdrop-blur-sm flex items-center gap-2 min-h-[48px] hover:border-pink-300 transition-colors duration-200"
                          >
                            {followUpFormData.assignedTeamMember && followUpFormData.assignedTeamMember.length > 0 ? (
                              <div className="flex items-center gap-2 flex-1 flex-wrap">
                                {followUpFormData.assignedTeamMember.slice(0, 4).map(id => {
                                  const member = employees.find(m => (m._id || m.id) === id);
                                  const name = member ? (member.teamMemberName || member.name || 'U') : 'U';
                                  return (
                                    <div key={id} className="w-8 h-8 rounded-full bg-pink-50 border border-pink-200 flex items-center justify-center text-pink-600 text-xs font-semibold">
                                      {name.charAt(0).toUpperCase()}
                                    </div>
                                  );
                                })}
                                {followUpFormData.assignedTeamMember.length > 4 && (
                                  <div className="text-xs text-gray-500">+{followUpFormData.assignedTeamMember.length - 4}</div>
                                )}
                              </div>
                            ) : (
                              <span className="text-gray-500 flex-1">Select team members</span>
                            )}
                            <ChevronRight className={`w-4 h-4 text-gray-400 ml-auto transition-transform duration-200 ${openTeamMemberDropdown ? 'rotate-90' : ''}`} />
                          </div>

                          {openTeamMemberDropdown && (() => {
                            // Filter to show all active employees
                            const activeEmployees = employees.filter(emp =>
                              emp.isActive !== false && emp.status !== 'Inactive' && emp.status !== 'Deactive'
                            );

                            return (
                              <div className="absolute top-full left-0 right-0 bg-white/95 backdrop-blur-lg border border-gray-300 rounded-lg shadow-xl z-20 max-h-56 overflow-y-auto mt-2">
                                {activeEmployees.map((member, index) => (
                                  <div
                                    key={member._id}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      const isSelected = followUpFormData.assignedTeamMember.includes(member._id);
                                      if (isSelected) {
                                        setFollowUpFormData(prev => ({
                                          ...prev,
                                          assignedTeamMember: prev.assignedTeamMember.filter(id => id !== member._id)
                                        }));
                                      } else {
                                        setFollowUpFormData(prev => ({
                                          ...prev,
                                          assignedTeamMember: [...prev.assignedTeamMember, member._id]
                                        }));
                                      }
                                    }}
                                    className={`p-3 cursor-pointer border-b border-gray-100 last:border-b-0 flex items-center space-x-3 transition-colors duration-200 ${followUpFormData.assignedTeamMember.includes(member._id)
                                      ? 'bg-gradient-to-r from-pink-50 to-rose-50 border-l-4 border-l-pink-400'
                                      : 'hover:bg-gray-50'
                                      }`}
                                  >
                                    <div className="w-8 h-8 rounded-full bg-pink-50 border border-pink-200 flex items-center justify-center text-pink-600 text-xs font-semibold">
                                      {(member.teamMemberName || member.name || 'U').charAt(0).toUpperCase()}
                                    </div>
                                    <div className="flex-1">
                                      <p className="text-sm font-medium text-gray-900">
                                        {member.teamMemberName || member.name || 'Unnamed'}
                                      </p>
                                      <p className="text-xs text-gray-500">{member.role || 'No Position'}</p>
                                    </div>
                                    <input
                                      type="checkbox"
                                      checked={followUpFormData.assignedTeamMember.includes(member._id)}
                                      readOnly
                                      className="rounded border-gray-300 text-pink-600 focus:ring-pink-500"
                                    />
                                  </div>
                                ))}

                                {(!activeEmployees || activeEmployees.length === 0) && (
                                  <div className="p-3 text-sm text-gray-500 text-center bg-gray-50/50">
                                    No active team members available
                                  </div>
                                )}
                              </div>
                            );
                          })()}
                        </div>

                        <div>
                          <label htmlFor="nextFollowUp" className="block text-sm font-medium text-gray-700 mb-1">Next Follow-up Date</label>
                          <input
                            type="date"
                            id="nextFollowUp"
                            name="nextFollowUp"
                            value={followUpFormData.nextFollowUp}
                            onChange={handleFollowUpChange}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition-colors duration-200 bg-white/50 backdrop-blur-sm"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label htmlFor="dueDate" className="block text-sm font-medium text-gray-700 mb-1">
                          Due Date *
                        </label>
                        <input
                          type="date"
                          id="dueDate"
                          name="dueDate"
                          value={followUpFormData.dueDate}
                          onChange={handleFollowUpChange}
                          required
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition-colors duration-200 bg-white/50 backdrop-blur-sm"
                        />
                      </div>

                      <div>
                        <label htmlFor="status" className="block text-sm font-medium text-gray-700 mb-1">
                          Status
                        </label>
                        <select
                          id="status"
                          name="status"
                          value={followUpFormData.status}
                          onChange={handleFollowUpChange}
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition-colors duration-200 bg-white/50 backdrop-blur-sm"
                        >
                          <option value="">-- Select Status --</option>
                          {statusOptions.map(opt => (
                            <option key={opt} value={opt}>{opt}</option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="flex justify-end space-x-3 pt-4">
                      <button
                        type="button"
                        onClick={() => setShowFollowUpForm(false)}
                        className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200 font-medium"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-2 bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 text-white rounded-lg transition-all duration-200 font-medium flex items-center space-x-2 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                      >
                        <Plus className="w-4 h-4" />
                        <span>Create Task</span>
                      </button>
                    </div>
                  </form>
                </div>
              )}

              {/* Tasks List */}
              {localMilestones.length > 0 ? (
                <div className="space-y-4">
                  {localMilestones.map((ms, index) => {
                    const calculateDynamicStatus = (milestone) => {
                      const currentDate = new Date();
                      const dueDate = milestone.dueDate ? new Date(milestone.dueDate) : null;
                      const status = milestone.status || 'Pending';

                      // Always respect the manually set status from the database
                      // Only add "Late Completed" logic for completed tasks
                      if (status === 'Completed') {
                        if (dueDate && currentDate > dueDate) {
                          return 'Late Completed';
                        }
                        return 'Completed';
                      }

                      // For all other statuses (In Progress, Pending, Overdue, etc.)
                      // Return the status as set by the user - don't override it
                      return status;
                    };

                    const dynamicStatus = calculateDynamicStatus(ms);

                    return (
                      <div key={ms._id || ms.id || `milestone-${index}`} className="bg-gradient-to-r from-white/50 to-gray-50/50 rounded-xl p-4 border border-gray-200/50 hover:border-pink-200/50 transition-all duration-200 hover:shadow-lg backdrop-blur-sm">
                        <div className="flex items-start justify-between">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <h4 className="font-semibold text-gray-900">{ms.title}</h4>
                            </div>

                            {ms.description && (
                              <p className="text-gray-600 text-sm mb-3 bg-white/30 p-3 rounded-lg border border-gray-200/30">{ms.description}</p>
                            )}

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm text-gray-500">
                              <div className="flex items-center space-x-2">
                                <div className="p-1 bg-blue-100 rounded">
                                  <Calendar className="w-3 h-3 text-blue-600" />
                                </div>
                                <span>Due: {ms.dueDate ? fmtDate(ms.dueDate) : 'No date set'}</span>
                              </div>

                              {ms.assignedTeamMember && (
                                <div className="flex items-center space-x-2">
                                  <div className="p-1 bg-orange-100 rounded">
                                    <Users className="w-3 h-3 text-orange-600" />
                                  </div>
                                  <span>
                                    {Array.isArray(ms.assignedTeamMember) ? (
                                      ms.assignedTeamMember.length > 0 ? (
                                        <span className="truncate max-w-[200px] inline-block align-bottom" title={
                                          ms.assignedTeamMember.map(id => {
                                            const member = typeof id === 'object' ? id : employees.find(m => String(m._id || m.id) === String(id));
                                            return member ? (member.teamMemberName || member.name || 'Unknown') : 'Unknown';
                                          }).join(', ')
                                        }>
                                          {ms.assignedTeamMember.map(id => {
                                            const member = typeof id === 'object' ? id : employees.find(m => String(m._id || m.id) === String(id));
                                            return member ? (member.teamMemberName || member.name || 'Unknown') : 'Unknown';
                                          }).join(', ')}
                                        </span>
                                      ) : (
                                        <span>Unassigned</span>
                                      )
                                    ) : (
                                      <span className="truncate max-w-[200px] inline-block align-bottom">
                                        {(() => {
                                          const id = ms.assignedTeamMember;
                                          const member = typeof id === 'object' ? id : employees.find(m => String(m._id || m.id) === String(id));
                                          return member ? (member.teamMemberName || member.name || 'Unknown') : 'Assigned';
                                        })()}
                                      </span>
                                    )}
                                  </span>
                                </div>
                              )}

                              {ms.nextFollowUp && (
                                <div className="flex items-center space-x-2">
                                  <div className="p-1 bg-purple-100 rounded">
                                    <Clock className="w-3 h-3 text-purple-600" />
                                  </div>
                                  <span>Follow-up: {fmtDate(ms.nextFollowUp)}</span>
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="flex items-center space-x-2 ml-4">
                            <select
                              value={ms.status || 'Pending'}
                              onChange={(e) => handleStatusChange(ms._id || ms.id, e.target.value)}
                              className="px-3 py-1.5 text-sm text-gray-700 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pink-500 focus:border-pink-500 transition-colors duration-200 bg-white/80 backdrop-blur-sm shadow-sm cursor-pointer hover:border-pink-300"
                            >
                              {(statusOptions.length > 0 ? statusOptions : ['Pending', 'In Progress', 'Completed']).map((status, statusIndex) => (
                                <option key={statusIndex} value={status}>
                                  {status}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : (
                !showFollowUpForm && (
                  <div className="text-center py-8 text-gray-500 bg-gradient-to-r from-pink-50/30 to-rose-50/30 rounded-xl border border-pink-200/30">
                    <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-3 border border-pink-200">
                      <Target className="w-8 h-8 text-pink-400" />
                    </div>
                    <p>No tasks created for this project</p>
                  </div>
                )
              )}
            </div>

            {/* Description Card */}
            <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-gray-200/50 p-6 hover:shadow-2xl transition-all duration-300">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
                <div className="p-2 bg-gradient-to-r from-blue-100 to-blue-200 rounded-lg">
                  <FileText className="w-5 h-5 text-blue-600" />
                </div>
                <span>Description</span>
              </h3>
              <p className="text-gray-700 leading-relaxed bg-gradient-to-r from-blue-50/50 to-purple-50/50 p-4 rounded-xl border border-blue-100/50">
                {project.description || 'No description provided.'}
              </p>
            </div>

            {/* Department Section */}
            {project.department && (
              <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-gray-200/50 p-6 hover:shadow-2xl transition-all duration-300">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
                  <div className="p-2 bg-gradient-to-r from-green-100 to-green-200 rounded-lg">
                    <Building2 className="w-5 h-5 text-green-600" />
                  </div>
                  <span>Department</span>
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {Array.isArray(project.department) ? (
                    project.department.map((dept, idx) => {
                      let deptName = 'Unknown Department';
                      if (typeof dept === 'object' && dept.name) {
                        deptName = dept.name;
                      } else if (typeof dept === 'string') {
                        const foundDept = department.find(d => d._id === dept || d.id === dept);
                        deptName = foundDept ? (foundDept.name || foundDept.departmentName || 'Unknown Department') : dept;
                      }
                      return (
                        <div key={idx} className="bg-gradient-to-r from-green-50/50 to-emerald-50/50 rounded-xl p-4 border border-green-200/50 hover:border-green-300/50 transition-colors duration-200">
                          <div className="flex items-center space-x-3">
                            <div className="p-2 bg-green-100 rounded-lg">
                              <Building2 className="w-5 h-5 text-green-600" />
                            </div>
                            <div>
                              <p className="text-sm text-gray-600">Department</p>
                              <p className="font-semibold text-gray-900">{deptName}</p>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="bg-gradient-to-r from-green-50/50 to-emerald-50/50 rounded-xl p-4 border border-green-200/50 hover:border-green-300/50 transition-colors duration-200">
                      <div className="flex items-center space-x-3">
                        <div className="p-2 bg-green-100 rounded-lg">
                          <Building2 className="w-5 h-5 text-green-600" />
                        </div>
                        <div>
                          <p className="text-sm text-gray-600">Department</p>
                          <p className="font-semibold text-gray-900">
                            {(() => {
                              if (typeof project.department === 'object' && project.department.name) {
                                return project.department.name;
                              } else if (typeof project.department === 'string') {
                                const foundDept = department.find(d => d._id === project.department || d.id === project.department);
                                return foundDept ? (foundDept.name || foundDept.departmentName || 'Unknown Department') : project.department;
                              }
                              return 'Unknown Department';
                            })()}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Project Head */}
            {project.projectHead && (
              <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-gray-200/50 p-6 hover:shadow-2xl transition-all duration-300">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
                  <div className="p-2 bg-gradient-to-r from-purple-100 to-purple-200 rounded-lg">
                    <User className="w-5 h-5 text-purple-600" />
                  </div>
                  <span>Project Head</span>
                </h3>
                <div className="bg-gradient-to-r from-purple-50/50 to-pink-50/50 rounded-xl p-4 border border-purple-200/50">
                  {(() => {
                    let projectHeadDetails = null;
                    const projectHeadId = typeof project.projectHead === 'string' ? project.projectHead : project.projectHead?._id;
                    const detailedProjectHead = employeeDetails[projectHeadId];

                    if (detailedProjectHead) {
                      projectHeadDetails = detailedProjectHead;
                    } else if (typeof project.projectHead === 'object' && (project.projectHead.name || project.projectHead.teamMemberName)) {
                      projectHeadDetails = project.projectHead;
                    } else if (typeof project.projectHead === 'string' && employees.length > 0) {
                      projectHeadDetails = employees.find(emp => String(emp._id) === String(project.projectHead));
                    }

                    if (projectHeadDetails) {
                      const position = projectHeadDetails.role ||
                        projectHeadDetails.position ||
                        projectHeadDetails.designation ||
                        projectHeadDetails.jobTitle ||
                        projectHeadDetails.title ||
                        projectHeadDetails.employeePosition ||
                        projectHeadDetails.department ||
                        'Position not available';

                      return (
                        <div className="flex items-center space-x-4">
                          <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center shadow-lg">
                            <User className="w-6 h-6 text-white" />
                          </div>
                          <div className="flex-1">
                            <h4 className="font-semibold text-gray-900">
                              {projectHeadDetails.teamMemberName || projectHeadDetails.name || 'Unknown'}
                            </h4>
                            {projectHeadDetails.email && (
                              <p className="text-sm text-gray-600 mt-1"> {projectHeadDetails.email}</p>
                            )}
                            <p className="text-sm text-gray-500 mt-1">💼 {position}</p>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <p className="text-gray-600 italic bg-white/50 p-3 rounded-lg border border-gray-200/50">
                          Project Head ID: {String(project.projectHead)}
                        </p>
                      );
                    }
                  })()}
                </div>
              </div>
            )}

            {/* Team Members */}
            <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-gray-200/50 p-6 hover:shadow-2xl transition-all duration-300">
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
                <div className="p-2 bg-gradient-to-r from-orange-100 to-orange-200 rounded-lg">
                  <Users className="w-5 h-5 text-orange-600" />
                </div>
                <span>Team Members</span>
              </h3>

              {teamMembers.length > 0 ? (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {teamMembers.map((member, index) => (
                    <div key={member._id || index} className="bg-gradient-to-r from-orange-50/50 to-amber-50/50 rounded-xl p-4 border border-orange-200/50 hover:border-orange-300/50 transition-all duration-200 hover:shadow-lg">
                      <div className="flex items-center space-x-3">
                        <div className="w-10 h-10 bg-gradient-to-r from-orange-400 to-amber-400 rounded-full flex items-center justify-center shadow-md">
                          <User className="w-5 h-5 text-white" />
                        </div>
                        <div className="flex-1">
                          <h4 className="font-semibold text-gray-900 text-sm">
                            {member.teamMemberName || member.name}
                          </h4>
                          {member.email && (
                            <p className="text-xs text-gray-600 mt-1"> {member.email}</p>
                          )}
                          <p className="text-xs text-gray-500 mt-1">💼 {member.role || 'Position not available'}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-8 text-gray-500 bg-gradient-to-r from-orange-50/30 to-amber-50/30 rounded-xl border border-orange-200/30">
                  <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3 border border-orange-200">
                    <Users className="w-8 h-8 text-orange-400" />
                  </div>
                  <p>No team members added</p>
                </div>
              )}
            </div>

            {/* Client Information */}
            {(project.clientName || project.clientCompany || project.clientEmail || project.clientMobileNo || project.clientAddress || project.clientCity || project.clientState) && (
              <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-gray-200/50 p-6 hover:shadow-2xl transition-all duration-300">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
                  <div className="p-2 bg-gradient-to-r from-cyan-100 to-cyan-200 rounded-lg">
                    <Briefcase className="w-5 h-5 text-cyan-600" />
                  </div>
                  <span>Client Information</span>
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {project.clientName && (
                    <div className="bg-gradient-to-r from-cyan-50/50 to-blue-50/50 rounded-xl p-4 border border-cyan-200/50 hover:border-cyan-300/50 transition-colors duration-200">
                      <div className="flex items-center space-x-3">
                        <div className="p-2 bg-cyan-100 rounded-lg">
                          <User className="w-5 h-5 text-cyan-600" />
                        </div>
                        <div>
                          <p className="text-sm text-gray-600">Name</p>
                          <p className="font-semibold text-gray-900">{project.clientName}</p>
                        </div>
                      </div>
                    </div>
                  )}
                  {project.clientCompany && (
                    <div className="bg-gradient-to-r from-blue-50/50 to-indigo-50/50 rounded-xl p-4 border border-blue-200/50 hover:border-blue-300/50 transition-colors duration-200">
                      <div className="flex items-center space-x-3">
                        <div className="p-2 bg-blue-100 rounded-lg">
                          <Building2 className="w-5 h-5 text-blue-600" />
                        </div>
                        <div>
                          <p className="text-sm text-gray-600">Company</p>
                          <p className="font-semibold text-gray-900">{project.clientCompany}</p>
                        </div>
                      </div>
                    </div>
                  )}
                  {project.clientEmail && (
                    <div className="bg-gradient-to-r from-purple-50/50 to-pink-50/50 rounded-xl p-4 border border-purple-200/50 hover:border-purple-300/50 transition-colors duration-200">
                      <div className="flex items-center space-x-3">
                        <div className="p-2 bg-purple-100 rounded-lg">
                          <Mail className="w-5 h-5 text-purple-600" />
                        </div>
                        <div>
                          <p className="text-sm text-gray-600">Email</p>
                          <p className="font-semibold text-gray-900">{project.clientEmail}</p>
                        </div>
                      </div>
                    </div>
                  )}
                  {project.clientMobileNo && (
                    <div className="bg-gradient-to-r from-green-50/50 to-emerald-50/50 rounded-xl p-4 border border-green-200/50 hover:border-green-300/50 transition-colors duration-200">
                      <div className="flex items-center space-x-3">
                        <div className="p-2 bg-green-100 rounded-lg">
                          <Phone className="w-5 h-5 text-green-600" />
                        </div>
                        <div>
                          <p className="text-sm text-gray-600">Mobile</p>
                          <p className="font-semibold text-gray-900">{project.clientMobileNo}</p>
                        </div>
                      </div>
                    </div>
                  )}
                  {project.clientAddress && (
                    <div className="bg-gradient-to-r from-red-50/50 to-orange-50/50 rounded-xl p-4 border border-red-200/50 hover:border-red-300/50 transition-colors duration-200 md:col-span-2">
                      <div className="flex items-center space-x-3">
                        <div className="p-2 bg-red-100 rounded-lg">
                          <MapPin className="w-5 h-5 text-red-600" />
                        </div>
                        <div>
                          <p className="text-sm text-gray-600">Address</p>
                          <p className="font-semibold text-gray-900">{project.clientAddress}</p>
                        </div>
                      </div>
                    </div>
                  )}
                  {project.clientCity && (
                    <div className="bg-gradient-to-r from-indigo-50/50 to-violet-50/50 rounded-xl p-4 border border-indigo-200/50 hover:border-indigo-300/50 transition-colors duration-200">
                      <div className="flex items-center space-x-3">
                        <div className="p-2 bg-indigo-100 rounded-lg">
                          <MapPin className="w-5 h-5 text-indigo-600" />
                        </div>
                        <div>
                          <p className="text-sm text-gray-600">City</p>
                          <p className="font-semibold text-gray-900">{project.clientCity}</p>
                        </div>
                      </div>
                    </div>
                  )}
                  {project.clientState && (
                    <div className="bg-gradient-to-r from-emerald-50/50 to-teal-50/50 rounded-xl p-4 border border-emerald-200/50 hover:border-emerald-300/50 transition-colors duration-200">
                      <div className="flex items-center space-x-3">
                        <div className="p-2 bg-emerald-100 rounded-lg">
                          <MapPin className="w-5 h-5 text-emerald-600" />
                        </div>
                        <div>
                          <p className="text-sm text-gray-600">State</p>
                          <p className="font-semibold text-gray-900">{project.clientState}</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
          {/* Right Column - Project Overview */}
          <div className="space-y-8">
            {/* Project Overview Card */}
            <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-gray-200/50 p-6 hover:shadow-2xl transition-all duration-300">
              <h3 className="text-lg font-semibold text-gray-900 mb-6 flex items-center space-x-2">
                <div className="p-2 bg-gradient-to-r from-indigo-100 to-indigo-200 rounded-lg">
                  <BarChart3 className="w-5 h-5 text-indigo-600" />
                </div>
                <span>Project Overview</span>
              </h3>

              <div className="space-y-6">
                {/* Progress */}
                <div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="text-sm font-medium text-gray-700">Progress</span>
                    <span className="text-sm font-semibold text-blue-600">{progress}%</span>
                  </div>
                  <div className="w-full bg-gradient-to-r from-gray-200 to-gray-300 rounded-full h-3 shadow-inner">
                    <div
                      className="bg-gradient-to-r from-blue-500 to-purple-600 h-3 rounded-full transition-all duration-500 shadow-lg"
                      style={{ width: `${progress}%` }}
                    ></div>
                  </div>
                </div>

                {/* Status */}
                <div>
                  <span className="text-sm font-medium text-gray-700 block mb-2">Status</span>
                  <span className={getStatusBadgeStyle(project.status)}>
                    {project.status || 'Unknown'}
                  </span>
                </div>

                {/* Dates */}
                <div className="space-y-3">
                  <div className="flex items-center justify-between p-3 bg-gradient-to-r from-blue-50/50 to-cyan-50/50 rounded-xl border border-blue-200/50">
                    <div className="flex items-center space-x-2">
                      <div className="p-1 bg-blue-100 rounded">
                        <Calendar className="w-4 h-4 text-blue-600" />
                      </div>
                      <span className="text-sm text-gray-600">Start Date</span>
                    </div>
                    <span className="text-sm font-medium text-gray-900">{fmtDate(start)}</span>
                  </div>

                  <div className="flex items-center justify-between p-3 bg-gradient-to-r from-purple-50/50 to-pink-50/50 rounded-xl border border-purple-200/50">
                    <div className="flex items-center space-x-2">
                      <div className="p-1 bg-purple-100 rounded">
                        <Calendar className="w-4 h-4 text-purple-600" />
                      </div>
                      <span className="text-sm text-gray-600">Due Date</span>
                    </div>
                    <span className="text-sm font-medium text-gray-900">{fmtDate(due)}</span>
                  </div>
                </div>

                {/* Budget */}
                <div className="flex items-center justify-between p-3 bg-gradient-to-r from-green-50/50 to-emerald-50/50 rounded-xl border border-green-200/50">
                  <div className="flex items-center space-x-2">
                    <div className="p-1 bg-green-100 rounded">
                      <IndianRupee className="w-4 h-4 text-green-600" />
                    </div>
                    <span className="text-sm text-gray-600">Budget</span>
                  </div>
                  <span className="text-sm font-medium text-gray-900">
                    ₹{budget.toLocaleString('en-IN')}
                  </span>
                </div>

                {/* Timeline */}
                <div className="pt-4 border-t border-gray-200/50">
                  <h4 className="text-sm font-medium text-gray-700 mb-3">Timeline</h4>
                  <div className="space-y-2">
                    <div className="flex items-center justify-between text-sm p-2 bg-gradient-to-r from-orange-50/30 to-amber-50/30 rounded-lg">
                      <span className="text-gray-600">Created</span>
                      <span className="font-medium text-gray-900">
                        {project.createdAt ? new Date(project.createdAt).toLocaleDateString('en-GB') : 'N/A'}
                      </span>
                    </div>
                    <div className="flex items-center justify-between text-sm p-2 bg-gradient-to-r from-cyan-50/30 to-blue-50/30 rounded-lg">
                      <span className="text-gray-600">Last Updated</span>
                      <span className="font-medium text-gray-900">
                        {project.updatedAt ? new Date(project.updatedAt).toLocaleDateString('en-GB') : 'N/A'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Custom Fields */}
            {project.customFields && project.customFields.length > 0 && (
              <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-gray-200/50 p-6 hover:shadow-2xl transition-all duration-300">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center space-x-2">
                  <div className="p-2 bg-gradient-to-r from-teal-100 to-teal-200 rounded-lg">
                    <FileText className="w-5 h-5 text-teal-600" />
                  </div>
                  <span>Additional Information</span>
                </h3>
                <div className="space-y-3">
                  {project.customFields.map((field, index) => (
                    <div key={index} className="bg-gradient-to-r from-teal-50/50 to-cyan-50/50 rounded-xl p-3 border border-teal-200/50 hover:border-teal-300/50 transition-colors duration-200">
                      <p className="text-sm text-gray-600 mb-1">{field.key}</p>
                      <p className="font-medium text-gray-900">{field.value}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* Quick Stats */}
            <div className="bg-white/80 backdrop-blur-lg rounded-2xl shadow-xl border border-gray-200/50 p-6 hover:shadow-2xl transition-all duration-300">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Stats</h3>
              <div className="space-y-4">
                <div className="flex items-center justify-between p-3 bg-gradient-to-r from-violet-50/50 to-purple-50/50 rounded-xl border border-violet-200/50">
                  <span className="text-sm text-gray-600">Total Tasks</span>
                  <span className="font-semibold text-gray-900 bg-white/50 px-2 py-1 rounded-lg border border-violet-200/50">
                    {localMilestones.length}
                  </span>
                </div>
                <div className="flex items-center justify-between p-3 bg-gradient-to-r from-amber-50/50 to-orange-50/50 rounded-xl border border-amber-200/50">
                  <span className="text-sm text-gray-600">Team Members</span>
                  <span className="font-semibold text-gray-900 bg-white/50 px-2 py-1 rounded-lg border border-amber-200/50">
                    {teamMembers.length}
                  </span>
                </div>
                <div className="flex items-center justify-between p-3 bg-gradient-to-r from-rose-50/50 to-pink-50/50 rounded-xl border border-rose-200/50">
                  <span className="text-sm text-gray-600">Days Remaining</span>
                  <span className="font-semibold text-gray-900 bg-white/50 px-2 py-1 rounded-lg border border-rose-200/50">
                    {due ? Math.ceil((due - new Date()) / (1000 * 60 * 60 * 24)) : 'N/A'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectView;

